const ACTIVE_ENV = 'PROD';
const ENVS = {
  DEV: {
    BASE_URL: 'https://api.dev.hav-g.in/',
    CAPI_URL: 'https://public-zxhj2.dev.hav-g.in/',
    AUTH_TOKEN: 'e2623576-930b-48b6-81e2-a3cb5e37f47d',
  },
  PROD: {
    BASE_URL: 'https://api.hav-g.in/',
    CAPI_URL: 'https://public-jgfas325.hav-g.in/',
    AUTH_TOKEN: 'd7ef603e-71ea-44a1-93f2-2bacd08c4a90',
  },
};

const ENV = ENVS[ACTIVE_ENV];
let trayaProcessingAnimation = document.getElementById('traya-processing-animation');
const CONFIG = {
  BASE_URL: ENV.BASE_URL,
  CAPI_URL: ENV.CAPI_URL,
  AUTH_HEADER: { Authorization: `Bearer ${ENV.AUTH_TOKEN}` },
  JSON_HEADERS: { 'Content-Type': 'application/json' },
};

const state = {
  id: null,
  caseId: null,
  f_name: null,
  C_number: null,
  C_email: null,
  user_gender: null,
  userHairStage: null,
  pdPrice: 0,
  strikeFinalCartPrice: 0,
};

function getUrlParam(name) {
  return new URLSearchParams(window.location.search).get(name);
}

function getCookieValue(name) {
  const match = document.cookie.split(';').find(c => c.trim().startsWith(name + '='));
  return match ? match.trim().split('=').slice(1).join('=') : null;
}

function qs(selector, root = document) {
  return root.querySelector(selector);
}

function qsa(selector, root = document) {
  return root.querySelectorAll(selector);
}

(function init() {
  const urlId = getUrlParam('id');
  if (urlId) {
    localStorage.setItem('user-gender', 'female');
    localStorage.setItem('rid', urlId);
  }

  state.id = localStorage.getItem('rid') || getCookieValue('syntheticId');

  if (!state.id) {
    if (window.location.pathname === '/pages/result4') {
      alert('Your recommendation is not found. Please fill the diagnosis to help us share the recommended plan.');
      window.location.href = 'https://form.traya.health/questions?cohort=1&source=ResultPage';
    }
    return;
  }

  setotherCookie('syntheticId', state.id, 30, '.traya.health');
  fetchFemaleResult();
})();

function fetchFemaleResult() {
  const url = `${CONFIG.BASE_URL}dgReport/female?id=${state.id}&isWebsite=true`;
  document.body.style.overflow = 'hidden';

  fetch(url, { headers: CONFIG.AUTH_HEADER })
    .then(res => res.json())
    .then(handleFemaleResult)
    .catch(err => console.error('Network Error:', err))
    .finally(() => {
      document.body.style.overflow = '';
      clearCart();
    });
}

function handleFemaleResult(response) {
  if (response.message === 'Report is only for female') {
    window.location.href = `/pages/result4${window.location.search}`;
    return;
  }

  const analysis = response?.User_Analysis ?? {};
  state.caseId = analysis.case_id;
  caseId = state.caseId;
  tagClarityCaseId(caseId);
  state.userHairStage = analysis.hair_fall_stage?.toLowerCase();
  state.f_name    = analysis.first_name;
  state.C_number  = analysis.phone;
  state.C_email   = analysis.email;
  state.user_gender = analysis.gender;

  const validStage = state.userHairStage === "hair thinning"
    || state.userHairStage === "side thinning"
    || state.userHairStage === "no widening";
  const hairThinningExpectation = document.querySelector(".results-timeline-progress");
  const wideningExpectation = document.querySelector(".shopify-section.month-expectation--section");
  if (validStage) {
    if (wideningExpectation) wideningExpectation.classList.add('d-none');
  } else {
    if (hairThinningExpectation) hairThinningExpectation.classList.add('d-none');
  }
  const onboardingVideoElement = document.querySelector(".mini-onboarding-video--container");
  if(onboardingVideoElement && validStage){
    onboardingVideoElement.classList.remove('d-none');
    document.querySelectorAll(".video-wrapper").forEach(wrapper=>{
      initVideoPlayer(wrapper);
    });
  }

  setupWhatsAppWidget(analysis);
  userDetails(response);
  setupBookCallLink(state.caseId);
  setupClinicalEntryPoint(state.userHairStage);
  trackMetaEvent(analysis, 'Viewed Content');
  initResultsTimeline(response);
  sectionMonthsExpectetion(response);
  getProductByHandle(response);
  rootCause(response?.root_causes);
  displayStageSection(response);
  productComboKit(response);
  optionalAddOnProducts(response);
  headerLanguageSelectorFR7(state.userHairStage);
  // experiments
  setupHairRoutineBanner(state.caseId, state.userHairStage);
  initBannerPopup();
}

function initVideoPlayer(wrapper){
  const video = wrapper.querySelector("video");
  const source = wrapper.querySelector("source");
  const thumbnail = wrapper.querySelector(".video-thumbnail");
  const playBtn = wrapper.querySelector(".video-play-btn");
  const controls = wrapper.querySelector(".video-controls");
  const playToggle = wrapper.querySelector(".play-toggle");
  const muteToggle = wrapper.querySelector(".mute-toggle");
  const progressBar = wrapper.querySelector(".video-progress-bar");
  const progressContainer = wrapper.querySelector(".video-progress");
  let isDragging = false;
  let wasPlaying = false;
  let hideControlsTimer = null;
  function showControls(){
    controls.style.opacity = "1";
    clearTimeout(hideControlsTimer);
    hideControlsTimer = setTimeout(()=>{
      if(!video.paused && !isDragging){
        controls.style.opacity = "0";
      }
    },3000);
  }

  function startVideo(){
    if(!source.src){
      source.src = source.dataset.src;
      video.load();
    }
    video.style.display = "block";
    thumbnail.style.display = "none";
    playBtn.style.display = "none";
    controls.style.display = "flex";
    video.play();
    playToggle.innerHTML =
      `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/play.webp?v=1772691178" width="32" height="32">`;
    fireMiniVideoEvent("mini_onboarding_video_clicked", caseId);
    showControls();
  }

  function togglePlay(){
    if(video.paused){
      video.play();
      playToggle.innerHTML =
        `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/play.webp?v=1772691178" width="32" height="32">`;
      fireMiniVideoEvent("mini_onboarding_video_clicked", caseId);
    }else{
      video.pause();
      playToggle.innerHTML =
        `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/play_1.webp?v=1772691178" width="32" height="32">`;
      fireMiniVideoEvent("mini_onboarding_video_clicked", caseId);
    }
    showControls();
  }
  function seekVideo(clientX){
    const rect = progressContainer.getBoundingClientRect();
    const position = (clientX - rect.left) / rect.width;
    const clamped = Math.max(0, Math.min(1, position));
    const newTime = clamped * video.duration;
    video.currentTime = newTime;
    progressBar.style.width = clamped * 100 + "%";
    showControls();
  }
  function updateProgress(){
    if(!video.paused && !isDragging){
      const progress = (video.currentTime / video.duration) * 100;
      progressBar.style.width = progress + "%";
    }
    requestAnimationFrame(updateProgress);
  }
  /* Event Listeners */
  thumbnail.addEventListener("click", startVideo);
  playBtn.addEventListener("click", startVideo);

  video.addEventListener("click", togglePlay);
  playToggle.addEventListener("click", togglePlay);

  muteToggle.addEventListener("click", () => {
    const wasMuted = video.muted;
    video.muted = !video.muted;
    muteToggle.innerHTML = video.muted
      ? `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Frame_1_3ca2c8c9-08ab-4d12-b091-d05de7195269.webp?v=1772691138" width="20" height="19">`
      : `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Frame_a67f8797-6af8-4af0-9378-9106e26ae92e.webp?v=1772691138" width="20" height="19">`;
    if (wasMuted && !video.muted) {
      fireMiniVideoEvent("mini_onboarding_unmute_clicked", caseId);
    }
    showControls();
  });

  video.addEventListener("mousemove", showControls);
  video.addEventListener("touchstart", showControls);

  video.addEventListener("ended", () => {
    video.currentTime = 0;
    video.play();
  });

  progressContainer.addEventListener("click",(e)=>{
    seekVideo(e.clientX);
  });

  progressContainer.addEventListener("mousedown",(e)=>{
    isDragging = true;
    wasPlaying = !video.paused;
    video.pause();
    seekVideo(e.clientX);
    showControls();
  });

  document.addEventListener("mousemove",(e)=>{
    if(!isDragging) return;
    seekVideo(e.clientX);
  });

  document.addEventListener("mouseup",()=>{
    if(isDragging && wasPlaying){
      video.play();
    }
    isDragging = false;
    showControls();
  });
  progressContainer.addEventListener("touchstart",(e)=>{
    isDragging = true;
    wasPlaying = !video.paused;
    video.pause();
    seekVideo(e.touches[0].clientX);
    showControls();
  },{passive:true});
  progressContainer.addEventListener("touchmove",(e)=>{
    if(!isDragging) return;
    seekVideo(e.touches[0].clientX);
  },{passive:true});
  progressContainer.addEventListener("touchend",()=>{
    if(wasPlaying){
      video.play();
    }
    isDragging = false;
    showControls();
  });
  updateProgress();
}

function setupWhatsAppWidget(analysis) {
  const { case_id: caseId, case_created_date: formFillDateStr } = analysis;

  let formFillDate = new Date(formFillDateStr);
  if (isNaN(formFillDate.getTime())) {
    formFillDate = new Date(getCookieValue('current_D0_date'));
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  if (isNaN(formFillDate.getTime()) || formFillDate >= today) return;

  const isChatCase = caseId && /^[0-7]/.test(caseId);
  qs('.whats-app-wrapper-normal-user')?.classList.remove('d-none');
  qsa('.whats-app-wrapper-normal-user.chat-icon-click-event').forEach(el => {
    el.addEventListener('click', () => chatIconClicked('web_floating_icon_clicked', caseId));
  });
}

function setupBookCallLink(caseId) {
  const btn = qs('.fab-action-item.book-call-btn');
  if (btn) btn.href = `https://form.traya.health/pages/reschedule-slot/${caseId}?femaleResultPage=true`;
}

function setupClinicalEntryPoint(hairStage) {
  const validStages = new Set(['hair thinning', 'side thinning']);
  if (validStages.has(hairStage)) {
    qs('.clinical-entry-wrapper')?.classList.remove('d-none');
  }
}

function trackMetaEvent(analysis, eventName) {
  const body = {
    eventName,
    eventTime: Date.now(),
    email: analysis.email,
    phone: analysis.phone,
    fbc: getCookieValue('_fbc'),
    fbp: getCookieValue('_fbp'),
    url: window.location.href,
    domain: 'traya.health',
    gender: analysis.gender,
  };

  fetch(`${CONFIG.CAPI_URL}tracking`, {
    method: 'POST',
    headers: { ...CONFIG.JSON_HEADERS, ...CONFIG.AUTH_HEADER },
    body: JSON.stringify(body),
  });
}

function clearCart() {
  $.getJSON('/cart.js', function(cart) {
    if (cart.item_count === 0) { silentCheckout(); return; }
    $.ajax({
      type: 'POST',
      url: '/cart/clear.js',
      dataType: 'json',
      success: silentCheckout,
      error: err => console.error('Error clearing cart:', err),
    });
  });
}

function silentCheckout() {
  setCartButtonState('loading');
  localStorage.setItem('user__gender', state.user_gender);
  localStorage.setItem('caseId', state.caseId);
  let user_gender = state.user_gender === 'F' ? 'Female' : state.user_gender;
  const items = variantsIDs.map(item => ({
    ...item,
    properties: {
      Plan: 'Auto'
    }
  }));
  const formData = {
    items: items,
    attributes: {
      first_name: state.f_name,
      phone: state.C_number,
      email: state.C_email,
      caseid: state.caseId,
      user__gender: user_gender,
      hair_Stage: state.userHairStage
    }
  };
  fetch('/cart/add.js', {
    method: 'POST',
    headers: CONFIG.JSON_HEADERS,
    body: JSON.stringify(formData),
  })
    .then(res => res.json())
    .then(() => {
      localStorage.setItem('User_location', 'cart');
    })
    .catch(err => console.error('Silent checkout error:', err))
    .finally(() => {
      setTimeout(() => {
        setCartButtonState('ready');
        updateCartDrawer();
      }, 800);
    });
}

const LOADER_SVG = `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/tube-spinner_clockwise.svg?v=1746524502" class="loader-icon" alt="Loading...">`;

function setCartButtonState(state) {
  qsa('#add-to-cart-result-page-frp').forEach(btn => {
    const isLoading = state === 'loading';
    btn.innerHTML = isLoading ? LOADER_SVG : 'Buy Now';
    btn.disabled = isLoading;
    btn.classList.toggle('loader-added', isLoading);
  });
}

function updateCartDrawer() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const updates = Object.fromEntries(
        cart.items
          .filter(item => item.quantity === 2)
          .map(item => [item.key, 1])
      );

      if (Object.keys(updates).length === 0) return refreshCartUI();

      fetch('/cart/update.js', {
        method: 'POST',
        headers: CONFIG.JSON_HEADERS,
        body: JSON.stringify({ updates }),
      })
        .then(res => res.json())
        .then(refreshCartUI)
        .catch(err => console.error('Error updating quantities:', err));
    });
}

async function refreshCartUI() {
  try {
    const [bubbleData, drawerData] = await Promise.all([
      fetch('/?sections=cart-icon-bubble').then(r => r.json()),
      fetch('/?sections=cart-drawer').then(r => r.json()),
    ]);

    const cartIconBubble = document.getElementById('cart-icon-bubble');
    if (cartIconBubble && bubbleData['cart-icon-bubble']) {
      cartIconBubble.innerHTML = bubbleData['cart-icon-bubble'];
    }

    const cartDrawer = qs('cart-drawer');
    if (cartDrawer && drawerData['cart-drawer']) {
      cartDrawer.outerHTML = drawerData['cart-drawer'];
      setTimeout(bindCartDrawerEvents, 50);
      qsa('.cart-drawer .cart-item cart-remove-button, .cart-drawer quantity-input.quantity')
        .forEach(el => (el.style.display = 'none'));
    }
    let drawerTotalPrice = document.querySelectorAll('.totals__subtotal-value .drawer-strike-cart-total-price');
    setTimeout(() => {
      if (drawerTotalPrice.length !== 0) {
        drawerTotalPrice.forEach((price) => {
          price.innerHTML = `₹ ${state.strikeFinalCartPrice}`;
        });
      }
      const englishPlaceOrderText = document.querySelector(".purchase_cart_text");
      const marathiPlaceOrderText = document.querySelector(".marathi_purchase_cart_text");
      englishPlaceOrderText.classList.add('d-none');
      marathiPlaceOrderText.classList.remove('d-none');
    },1500 );
  } catch (err) {
    console.error('Error refreshing cart UI:', err);
  }
}

function bindCartDrawerEvents() {
  qs('.drawer__close')?.addEventListener('click', () => {
    qs('cart-drawer.drawer')?.classList.remove('active');
    qs('.cart-drawer__overlay')?.classList.remove('active');
  });
}

bindCartDrawerEvents();

// ─── MARATHI TRANSLATIONS ────────────────────────────────────────────────────

const ROOT_CAUSE_MR = {
  "Dandruff": {
    title: "Konda",
    description: "Kondya mule tumchya scalpmade jal jal hote, kesaanchi mule kamkuvat hotaat kinva kes galtaat"
  },
  "Autoimmune": {
    title: "Swayampratikaar",
    description: "Jevha tumchi rogpratikarakshakti kesaanchya kupaanvar halla karte tevha takkal padnyache thipke distaat, jya mule kes galtaat"
  },
  "Postpartum": {
    title: "Prasavottar",
    description: "Balachya janmanantar hormonal chadhutar kesaancha vaadhichya cycle madhe rok aantaat aani kes galtaat"
  },
  "Low Iron": {
    title: "Kami Iron",
    description: "Kami iron mule kesaanchya kupaanna oxygen pohochavnyachi shareerachi kshamta kami hote, jya mule kes galtaat"
  },
  "Hormones": {
    title: "Hormones",
    description: "Shareerat kes galtiche pramaan vaadhlyane hormones vaadhtaat jya mule kes galtaat aani kes paatal hotaat"
  },
  "Digestion": {
    title: "Pachan",
    description: "Kharab pachankriyamule kesaancha kupaanmadhe poshak tattvaanche shoshan aani puravtha maryadit hote, jya mule kes galtaat"
  },
  "Nutrition": {
    title: "Poshan",
    description: "Aavyashak vitamins aani minerals chya diet madhe abhaav mule kesaanche vaadhiche cycle bighadte aani kes galtaat"
  },
  "Metabolism": {
    title: "Metabolism",
    description: "Mand metabolism mule kesaanche poshak tattve shoshan ghenyachi aani puravnyachi shareerachi kshamta kami hote, jya mule kes galtaat"
  },
  "Stress": {
    title: "Taan",
    description: "Taan cha hormone tumche kes vaadhiche tappyapasun vishranti tappyat halavto, jya mule kes galtaat aani kes paatal hotaat"
  },
  "Sleep": {
    title: "Zop",
    description: "Kami zope mule shareerachi kesaanchi kupaanchi durasti karnyachi aani kes vaadhavnyachi kshamta kami hote, jya mule kes paatal hotaat"
  },
  "External Factors": {
    title: "Baharya ghatak",
    description: "Kathor rasyaan/ kadak paani kesaanchi taakad kamkuvat karte aani kes tuttaat aani paatal hotaat"
  },
  "Lifestyle": {
    title: "Jeevanshaili",
    description: "Chukichya jeevanshaili mule shareerachya taalula aavyashak poshak tattve puravnyacha kshamtevar parinaam hoto jya mule kes galtaat"
  }
};

const PRODUCT_TRANSLATIONS_MR = {
  "Anti Dandruff Lotion": {
    title: "Anti Dandruff Lotion",
    description: "Hatti kondyasathi khas upay"
  },
  "Her Santulan": {
    title: "Her Santulan",
    description: "Hormonal karnan mule honari kesgalti thambavnyas madat"
  },
  "Mom Santulan for Postpartum hair": {
    title: "Mom Santulan Prasutipurva Kesaansaathi",
    description: "Mom Santulan prasutinantar honari kesgalti kami karnyas madat karte"
  },
  "Mom Santulan": {
    title: "Mom Santulan",
    description: "Delivery nantar honari kesgalti control karte"
  },
  "Iron Santulan": {
    title: "Iron Santulan",
    description: "Naisargik ani Ayurvedic iron supplement"
  },
  "PCOS Santulan": {
    title: "PCOS Santulan",
    description: "PCOS mule honari kesgalti kami karnyas madat karte"
  },
  "PCOS": {
    title: "PCOS",
    description: "PCOS mule honari kesgalti kami karnyas madat karte"
  },
  "Thyro Santulan": {
    title: "Thyro Santulan",
    description: "Thyroid mule honari kesgalti kami karnyas madat karte"
  },
  "Gut Shuddhi": {
    title: "Gut Shuddhi",
    description: "Pachan sudharun sharirala poshan changle milnyas madat"
  },
  "Digest boost for Improved Digestive Ability": {
    title: "Digest boost Pachan Sudharnyasaathi",
    description: "Acidity, gas ani pot phugne yavar naisargik aram"
  },
  "Digest boost": {
    title: "Digest boost",
    description: "Digest Boost pachan sudharun kesgalti kami karnyas madat karte"
  },
  "Health Tatva": {
    title: "Health Tatva",
    description: "Energy vadhavnyasathi metabolism sudharte"
  },
  "Hair Vitamin for her": {
    title: "Hair Vitamin for her",
    description: "Kesanna laganare poshan puravnari supplements"
  },
  "Calm Ras": {
    title: "Calm Ras",
    description: "Taantanaava mule honare kes galne kami karnyaas madat karte"
  },
  "Nasal Ghrit": {
    title: "Nasal Ghrit",
    description: "Changli jhop ani kesanchya mulanna durust karnyasathi"
  },
  "Hair Ras": {
    title: "Hair Ras",
    description: "Majboot nirogi kesaansaathi aavshyak poshan pradaan karte"
  },
  "Anti-Dandruff Shampoo": {
    title: "Anti-Dandruff Shampoo",
    description: "Scalp kholvar swachh karun konda dur karte."
  },
  "Anti dandruff shampoo": {
    title: "Anti dandruff shampoo",
    description: "Scalp kholvar swachh karun konda dur karte."
  },
  "Recap Serum": {
    title: "Recap Serum",
    description: "Kes vadhisathi scientifically proven ghatak"
  },
  "Hair Active Serum": {
    title: "Hair Active Serum",
    description: "Vaigyanik pramane siddh jhalele Hair Growth Actives."
  },
  "Hair Santulan 01": {
    title: "Hair Santulan 01",
    description: "Kesanchya poshanasaathi naisargik aushadhi vanaspati."
  },
  "Hair Santulan 02": {
    title: "Hair Santulan 02",
    description: "Kesanchya poshanasaathi naisargik aushadhi vanaspati."
  },
  "Hair Santulan 03": {
    title: "Hair Santulan 03",
    description: "Kesanchya poshanasaathi naisargik aushadhi vanaspati."
  },
  "Hair Santulan 06": {
    title: "Hair Santulan 06",
    description: "Kesanchya poshanasaathi naisargik aushadhi vanaspati."
  },
  "Hair Ras 06": {
    title: "Hair Ras 06",
    description: "Majboot aani nirogi kesansaathi aavashyak poshan."
  },
  "Her Nourish": {
    title: "Her Nourish",
    description: "Kes patal hou det nahi, jyamule kes adhik daat aani nirogi hotat."
  },
  "Minoxidil 2%": {
    title: "Minoxidil 2%",
    description: "Navin kes yenyasathi hair regrowth booster"
  },
  "Minoxidil 5% alc free": {
    title: "Minoxidil 5% alc free",
    description: "Minoxidil 5% alcohol-free navin kes yenyas madat karte ani kes jast daat banavte"
  },
  "Ketoconazole 2% night lotion": {
    title: "Anti Dandruff Lotion",
    description: "Night lotion konda kami karun kesgalti kami karnyas madat karte"
  },
  "Kevon": {
    title: "Kevon",
    description: "Night lotion konda kami karun kesgalti kami karnyas madat karte"
  },
  "Scalp Oil": {
    title: "Scalp Oil",
    description: "Scalp oil scalp la poshan karun kes majboot karte"
  },
  "Nourish hair oil": {
    title: "Nourish hair oil",
    description: "Kesanna majbooti ani chamak dete"
  },
  "Shine Leave in Serum": {
    title: "Shine Leave in Serum",
    description: "Shine Serum kesanchi texture sudharun tyanna chamakdar ani healthy look dete."
  },
  "Defence Shampoo 180ml": {
    title: "Defence Shampoo",
    description: "Kholvar moisture deun dryness kami karte"
  },
  "Defence Shampoo": {
    title: "Defence Shampoo",
    description: "Kholvar moisture deun dryness kami karte"
  },
  "Defence Conditioner": {
    title: "Defence Conditioner",
    description: "Kesanna condition karun tyanchi texture soft ani smooth karte."
  },
  "Consti Clear for Improved Bowel Movement": {
    title: "Consti Clear Aatdyanchya Halchali Sudharnyasaathi",
    description: "Consti Clear pachan sudharun kesgalti kami karnyas madat karte"
  },
  "Consti Clear": {
    title: "Consti Clear",
    description: "Consti Clear pachan sudharun kesgalti kami karnyas madat karte"
  }
};

// ─── ROOT CAUSE MARATHI HELPER ───────────────────────────────────────────────

function getMarathiContent(title, englishDescription) {
  const match = ROOT_CAUSE_MR[title];
  return {
    title: match?.title || title,
    description: match?.description || englishDescription
  };
}

// ─── PRODUCT MARATHI HELPER ──────────────────────────────────────────────────
// Receives the canonical product name (from popOneLinerData.product) and
// matches it against PRODUCT_TRANSLATIONS_MR keys using includes().
// Falls back to English title / description if no Marathi entry exists.

function getProductMarathi(productName, fallbackText) {
  const normalizedName = productName?.trim().toLowerCase();

  const matchKey = Object.keys(PRODUCT_TRANSLATIONS_MR).find(
    key => normalizedName.includes(key.toLowerCase())
  );

  const match = PRODUCT_TRANSLATIONS_MR[matchKey];

  return {
    title: match?.title || productName,
    description: match?.description || fallbackText || ''
  };
}

// ─── LANGUAGE SELECTOR ───────────────────────────────────────────────────────
function setupLanguageToggle() {
  const langBtn = document.querySelector('.language-icon-toggle');
  const arrowIcon = document.querySelector('.language-arrow-icon');
  const langDropdown = document.querySelector('.language-dropdown');
  const headerWrapper = document.querySelector(".icons-flex-container");
  const langText = document.querySelector('.language-icon');
  const headerLanguageIcon = document.getElementById("language-icon-toggle");
  const params = new URLSearchParams(window.location.search);
  const currentPage = params.get("page");
  if (headerLanguageIcon) {
  const urlParams = new URLSearchParams(window.location.search);
  const utmCampaign = urlParams.get("utm_campaign") || "";
   const page = urlParams.get("page") || "";

 const hasAllKeys =
  (utmCampaign.includes("TRFTOF") &&
    utmCampaign.includes("OnlyMHCustomers") &&
    utmCampaign.includes("CelebSayaliSanjeev")) ||
  page.includes("marathi");
  console.log(urlParams.toString(), "TEST hasAllKeys", page, hasAllKeys);
  if (hasAllKeys) {
    headerLanguageIcon.classList.remove("d-none");
  } else {
    headerLanguageIcon.classList.add("d-none");
  }
}


  // Toggle dropdown
  langBtn?.addEventListener('click', () => {
    langDropdown?.classList.toggle('open');
    langBtn.classList.toggle('white-background');
    arrowIcon?.classList.toggle('rotate');
  });

  headerLanguageIcon?.addEventListener("click", (e) => {
    e.stopPropagation();
    document.getElementById("language-dropdown-toggle")?.classList.toggle("hidden");
    headerWrapper?.classList.toggle("hidden-dropdown");
  });

  document.querySelectorAll('.language-option').forEach(option => {
    option.addEventListener('click', function () {
      const selectedLang = this.getAttribute('lang');
      localStorage.setItem('selected_lang', selectedLang);
      // UI update
      if (langText) langText.textContent = selectedLang;

      document.querySelectorAll('.language-option').forEach(opt => opt.classList.remove('active'));
      this.classList.add('active');
    });
  });

  setLanguageFromStorage();
}

function setLanguageFromStorage() {
  const isFemaleResult7 = window.location.pathname.includes('female-result7');
  const selectedLang = isFemaleResult7 ? 'Marathish' : 'English';
  localStorage.setItem('selected_lang', selectedLang);
  const langText = document.querySelector('.language-icon');
  if (langText) langText.textContent = selectedLang;
  document.querySelectorAll('.language-option').forEach(opt => {
    opt.classList.remove('active');
    if (opt.getAttribute('lang') === selectedLang) {
      opt.classList.add('active');
    }
  });
}

function headerLanguageSelectorFR7(hairStage) {
  const id = new URLSearchParams(window.location.search);
  if (!id) return;

  const queryString = `?${id}`;
  const customValidStage = ["medium widening", "advanced widening", "coin size patches", "alopecia areata"];
  const validStage = ["hair thinning", "side thinning", "no widening"];

  let englishUrl = `/pages/female-result5${queryString}`;
  if (customValidStage.includes(hairStage)) {
    englishUrl = `/pages/female-result2${queryString}`;
  } else if (validStage.includes(hairStage)) {
    englishUrl = `/pages/female-result5${queryString}`;
  }

  const marathiUrl = `/pages/female-result7${queryString}`;
  const options = document.querySelectorAll(".language-option");

  options.forEach(link => {
    const lang = link.getAttribute("hreflang");
    if (lang === "english") link.href = englishUrl;
    if (lang === "marathish") link.href = marathiUrl;
  });

  options.forEach(link => link.classList.remove("active"));
  document.querySelector('[hreflang="marathish"]')?.classList.add("active");

  setupLanguageToggle();
}

// ─── HAIR STAGE MARATHI ───────────────────────────────────────────────────────

const HAIR_STAGE_MR = {
  "hair thinning": "Tumche kes sadhya paatal hot aahet",
  "advanced widening": "Tumhala sadhya pragat widening aahet.",
  "side thinning": "Tumche kes sadhya side ne paatal hot aahet.",
  "medium widening": "Tumhala sadhya madhyam widening aahet."
};

function getHairStageMarathi(stage) {
  return HAIR_STAGE_MR[stage?.toLowerCase()?.trim()] || stage;
}

const ASSESSMENT_TRANSLATIONS_MR = [
  {
    match: "Severe Hair Fall",
    value: "Tumhala sadhya jast pramanat hair fall hot aahet.<br>Ha teevra hair fall aapoaap thambnar nahi."
  },
  {
    match: "Hair fall is tough",
    value: "Kes galne kathin aahe pan aamhi tumchya sobat aahot"
  },
  {
    match: "experiencing Excessive Hair Fall",
    value: "Tumhala dekhil khup pramanat kes-galtee hot aahe.<br>Ti aankhi vadhnyachi vaat pahu naka"
  }
];

function getAssessmentMarathi(text) {
  if (!text) return "";
  const normalized = text.toLowerCase();
  const match = ASSESSMENT_TRANSLATIONS_MR.find(item =>
    normalized.includes(item.match.toLowerCase())
  );
  return match?.value || text;
}

// ─── RESULTS TIMELINE (SLICK CARD VERSION) ────────────────────────────────────

const RESULTS_TIMELINE_MR = {
  nonDandruff: [
    { month: "Mahina 1", goal: "Skalpche aarogya sudharte", image: "https://dvv8w2q8s3qot.cloudfront.net/App/Home/hairTexture1.png" },
    { month: "Mahina 2", goal: "Kamzor tutlele kes galltat", image: "https://dvv8w2q8s3qot.cloudfront.net/App/Home/white_residue_on_scalp_MG.png" },
    { month: "Mahina 3", goal: "Kes gallti niyantrit yete", image: "https://dvv8w2q8s3qot.cloudfront.net/App/Home/lessHairFall1.png" },
    { month: "Mahina 4", goal: "Naveen kesachi vaadh", image: "https://dvv8w2q8s3qot.cloudfront.net/App/Home/baby_hair_growth_MG.png" },
    { month: "Mahina 5", goal: "Jaad ani gulgulit kes, poorn skalp", image: "https://dvv8w2q8s3qot.cloudfront.net/App/Home/scalp_covered_MG.png" },
    { month: "Mahina 6", goal: "Nirogi kes - Mulapasun majboot", image: "https://dvv8w2q8s3qot.cloudfront.net/App/Home/newHeadofHair1.png" }
  ],
  dandruff: [
    { month: "Mahina 1", goal: "Dandruff chi kami hoti", image: "https://dvv8w2q8s3qot.cloudfront.net/App/Home/soothe_scalp_MG.png" },
    { month: "Mahina 2", goal: "Skalpche aarogya aage sudharte", image: "https://dvv8w2q8s3qot.cloudfront.net/App/Home/lessOilyScalp1.png" },
    { month: "Mahina 3", goal: "Kamzor tutlele kes galltat", image: "https://dvv8w2q8s3qot.cloudfront.net/App/Home/hairTexture1.png" },
    { month: "Mahina 4", goal: "Kes gallti niyantrit yete", image: "https://dvv8w2q8s3qot.cloudfront.net/App/Home/lessHairFall1.png" },
    { month: "Mahina 5", goal: "Naveen kesachi vaadh", image: "https://dvv8w2q8s3qot.cloudfront.net/App/Home/baby_hair_growth_MG.png" },
    { month: "Mahina 6", goal: "Jaad ani gulgulit kes, poorn skalp", image: "https://dvv8w2q8s3qot.cloudfront.net/App/Home/scalp_covered_MG.png" },
    { month: "Mahina 7", goal: "Kes adhik bharlele aani daat hotaat", image: "https://dvv8w2q8s3qot.cloudfront.net/App/Home/newHeadofHair1.png" }
  ]
};

function sectionMonthsExpectetion(response) {
  const { monthsExpectation } = response;
  if (!monthsExpectation?.monthExpectations || monthsExpectation.showComponent !== true) return;

  const timeline = document.getElementById('timeline');
  if (!timeline) return;

  timeline.innerHTML = '';

  const apiData = monthsExpectation.monthExpectations;
  const mrData = RESULTS_TIMELINE_MR.nonDandruff;
  const fragment = document.createDocumentFragment();

  apiData.slice(0, mrData.length).forEach((month, index) => {
    const mrItem = mrData[index];
    const block = document.createElement('div');
    block.className = 'timeline-block';
    block.innerHTML = `
      <div class="timeline-icon">
        <img src="${month.image_url}" alt="Month ${month.month}" width="100px" height="100px" loading="lazy">
      </div>
      ${index < apiData.length - 1 ? `
        <div class="timeline-dot-line">
          <div class="timeline-dot"></div>
          <div class="timeline-line"></div>
        </div>
      ` : ''}
      <div class="timeline-content">
        <p><strong>${mrItem?.month || month.month}</strong></p>
        <p class="monthe-suggestion">${mrItem?.goal || month.goal}</p>
      </div>
    `;
    fragment.appendChild(block);
  });

  timeline.appendChild(fragment);

  if (apiData.length <= 4) {
    timeline.classList.add('minus-the-margin');
    return;
  }

  if (window.innerWidth > 768) {
    $(timeline).slick({
      autoplay: false,
      autoplaySpeed: 3000,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: false,
      adaptiveHeight: false
    });
  }
}

// ─── ROOT CAUSE SECTION ──────────────────────────────────────────────────────

function rootCause(response) {
  const primaryRootCause = response?.primaryRootCause ?? [];
  const defaultRootCause = response?.defaultRootCause ?? [];

  function tabId(title) {
    return title.replace(/ /g, '-');
  }

  function buildNavItem(item, isActive = false) {
    const id = tabId(item.title);
    const marathi = getMarathiContent(item.title, item.details.description.english);
    return `
      <li class="rootCause-nav-item" role="presentation">
        <a class="rootCause-nav-link text-center${isActive ? ' active' : ''}"
          id="${id}-tab" data-toggle="tab" href="#${id}"
          role="tab" aria-controls="${id}" aria-selected="${isActive}">
          <div class="rootcause-tabs-image">
            <img src="${item.details.icon}" width="32" height="32" loading="eager" alt="${item.title}"/>
          </div>
          <p class="root-cause-title">${marathi.title}</p>
        </a>
      </li>`;
  }

  function buildTabPane(item, isActive = false) {
    const id = tabId(item.title);
    const marathi = getMarathiContent(item.title, item.details.description.english);
    return `
      <div class="tab-pane fade ${isActive ? ' show active' : ''}"
          id="${id}" role="tabpanel" aria-labelledby="${id}-tab">
        <p class="root-cause-title">${marathi.description}</p>
      </div>`;
  }

  const [primary] = primaryRootCause;
  const navItems = [
    ...(primary ? [buildNavItem(primary, true)] : []),
    ...defaultRootCause.map(item => buildNavItem(item)),
  ].join('');

  const tabPanes = [
    ...(primary ? [buildTabPane(primary, true)] : []),
    ...defaultRootCause.map(item => buildTabPane(item)),
  ].join('');

  const rootCauseSectionWrapper = document.getElementById('user-report-root-couse');
  if (rootCauseSectionWrapper) {
    rootCauseSectionWrapper.innerHTML = `
      <h2 class="rootcause-tabs--heading">Tumche kes galnyache mul kaaran</h2>
      <ul class="nav rootcause-tabs-tabs" id="myTab" role="tablist">${navItems}</ul>
      <div class="trootcause-Tab--Content" id="myTabContent">${tabPanes}</div>`;
  }

  if (trayaProcessingAnimation) trayaProcessingAnimation.style.display = 'none';
  document.body.style.overflow = 'unset';
}

function removeLoader() {
  let buyButtonLoader = document.querySelectorAll('#add-to-cart-result-page-frp');
  buyButtonLoader.forEach((eachBtn) => {
    eachBtn.innerHTML = "Buy Now";
    eachBtn.classList.remove('loader-added')
    eachBtn.disabled = false;
 });
}

// ─── USER DETAILS ────────────────────────────────────────────────────────────
function userDetails(response) {
  let { User_Analysis, Recommendations, stageTransition, assessmentReport, hideAssesmentImage } = response;
  let userName = qsa('user-name.user-name');
  let userName2 = qs('.result-product-kit-title');
  let userStage = qs('user-stage.user-stage');
  let reportStageContent = qsa('p.stage-report-content');
  let userStageBeforeImage = qs('img.user-before-image');
  let userStageAfterImage = qs('img.user-after-image');

  if (userName) { userName.forEach((name) => { name.innerHTML = `Hi, <span>${User_Analysis.first_name}</span>`; }); }
  if (userName2) { userName2.innerHTML = `<span data-user-name="" class="text-capitalize">${User_Analysis.first_name}</span>che 1 mahinyacha kit`; }
  if (userStage) {
    const marathiStage = getHairStageMarathi(User_Analysis.hair_fall_stage);
    userStage.innerHTML = `<strong>${marathiStage}</strong>`;
  }
  if(stageTransition.getYouHere){
    if (userStageAfterImage) userStageAfterImage.setAttribute("src", stageTransition.getYouHere);
    if (userStageBeforeImage) userStageBeforeImage.setAttribute("src", stageTransition.current);
  } else {
    qs('.report-user-stage-image').classList.add('d-none');
  }

  const defaultText = "While coin size patches cannot be cured, we offer a kit to help maintain your hair. Results may be limited due to the advanced stage of female hair loss, but we are here to support you.";
  const isCoinSizePatches = User_Analysis.hair_fall_stage.toLowerCase() === "coin size patches";
  const rawText = isCoinSizePatches
    ? defaultText
    : assessmentReport?.assessmentReport?.replace(/\n/g, "<br>");

  const displayText = getAssessmentMarathi(rawText);

  if (reportStageContent) {
    reportStageContent.forEach(stageReport => {
      stageReport.innerHTML = displayText;
    });
  }

  // chat flotie js 
  const fabWrapper = document.querySelector('.whats-app-wrapper-normal-user');
  const fabButton = document.getElementById('fabMainButton');
  const actionItems = document.querySelectorAll('.fab-action-item');

  if (!fabWrapper || !fabButton) return;

  let isExpanded = false;

  // Toggle FAB (open / close via main button)
  fabButton.addEventListener('click', function (e) {
    e.stopPropagation();

    fabWrapper.classList.toggle('expanded');
    isExpanded = fabWrapper.classList.contains('expanded');

    if (isExpanded) {
      chatIconClicked("web_floating_icon_clicked", caseId);
    } else {
      chatIconClicked("floating_icon_closed", caseId);
    }
  });

  // Close when clicking outside
  document.addEventListener('click', function (e) {
    if (isExpanded && !fabWrapper.contains(e.target)) {
      fabWrapper.classList.remove('expanded');
      isExpanded = false;
      chatIconClicked("floating_icon_closed", caseId);
    }
  });

  // CTA clicks (Chat / Book a Call)
  actionItems.forEach(item => {
    item.addEventListener('click', function (e) {
      e.stopPropagation();

      let ctaClicked = '';
      if (item.classList.contains('whatsapp-btn')) {
        ctaClicked = 'chat with us';
      } else if (item.classList.contains('book-call-btn')) {
        ctaClicked = 'book a call';
      }

      fetch("https://public-jgfas325.hav-g.in/eventMoengageWeb", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
        },
        body: JSON.stringify({
          "eventName": "floating_icon_cta_clicked",
          "eventAttributes": {
            "generalAttributes": {
              "platform": "web_shopify",
              "domain": "traya.health",
              "syntheticId": window.location.search.substring(1).split('=')[1] || "default-id",
              "cta_clicked": ctaClicked
            }
          },
          "caseId": caseId
        })
      });

    });
  });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isExpanded) {
      fabWrapper.classList.remove('expanded');
      isExpanded = false;
      chatIconClicked("floating_icon_closed", caseId);
    }
  });
  
  let buyButtonElement = document.querySelectorAll('#add-to-cart-result-page-frp');
  buyButtonElement.forEach((eachBtn) => {
    eachBtn.addEventListener('click', () => {
       eachBtn.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/tube-spinner_3.svg?v=1741241123" class="loader-icon" alt="Loading...">`;
       eachBtn.classList.add('loader-added')
       eachBtn.disabled = true;
       trackMetaEvent(response.User_Analysis, "Expand Benefits");
       window.umami.track('buy_now_click', {
        syntheticId: window.location.search.substring(1).split('=')[1] || "default-id",
        fingerprintId: window.__deviceId
      });
      setTimeout(() => {
        if (window.appliedReferralCode) {
          window.location.href = `/checkout?discount=${window.appliedReferralCode}`;
        } else {
          window.location.href = '/checkout';
        }
      }, 100);
      setTimeout(() => {
         removeLoader();
      }, 2000);
    });
  });
}

// ─── STAGE SECTION ───────────────────────────────────────────────────────────

const STAGE_IMAGES = {
  "hair thinning": {
    customerName: "Sakshi",
    images: [
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image_c2a537bc-4919-4b83-a12f-3767cb8d1b25.webp?v=1756899713",
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-1_3bca6c41-ac7a-4ec8-9a57-43b2dd498985.webp?v=1756899713",
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-2_7d151296-1377-4a5c-b218-da4db4a72c4c.webp?v=1756899713",
    ],
  },
  "medium widening": {
    customerName: "Poonam",
    images: [
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image_906439c7-0777-4323-a6fb-54e2226571be.webp?v=1756899831",
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-1_385b4e21-187d-4c80-bf27-4de49bb8b384.webp?v=1756899831",
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-2_1f4670c5-e3be-47a5-8890-fb50592e1dac.webp?v=1756899831",
    ],
  },
  "advanced widening": {
    customerName: "Pratima",
    images: [
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image_2_a6008d93-33ea-4539-a4f3-0a31b1e81546.webp?v=1756988341",
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-1_2.webp?v=1756988341",
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-2_1_5371c479-d809-4fc5-bd81-c1d1e6535b23.webp?v=1756988341",
    ],
  },
  "side thinning": {
    customerName: "Anjali",
    images: [
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image_1_0f684d2e-9d4b-4fc8-9c86-839c3d112433.webp?v=1756900221",
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-1_1_a54b4d61-d7b0-449b-80a5-8b8c7aeb624c.webp?v=1756900221",
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-2_1_0c8e0bca-7f44-40be-a1b5-5304dafe1c46.webp?v=1756900220",
    ],
  },
  "coin size patches": {
    customerName: "Supriya",
    images: [
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image_1_6041ce02-9314-4e64-8aff-668a3eba433a.webp?v=1756982697",
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-1_1_dd3429b7-2edc-4dd8-8d98-bd019141c6c0.webp?v=1756982697",
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-2_4aeb8cec-257c-454d-8434-548a24b29258.webp?v=1756900342",
    ],
  },
};

STAGE_IMAGES["alopecia areata"] = STAGE_IMAGES["coin size patches"];

const STAGE_ARROW_SVG = `
  <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
    <path d="M0.902344 16C0.902344 7.16344 8.06579 0 16.9023 0C25.7389 0 32.9023 7.16344 32.9023 16C32.9023 24.8366 25.7389 32 16.9023 32C8.06579 32 0.902344 24.8366 0.902344 16Z" fill="#EDD2CE"/>
    <path d="M13.7021 22.3984L20.1021 15.9984L13.7021 9.59844" stroke="#262626" stroke-width="1.6"/>
  </svg>`;

function displayStageSection(response) {
  const stageContainer = document.getElementById('customer-report-journey');
  if (!stageContainer) return;

  const userStage = response?.User_Analysis?.hair_fall_stage?.toLowerCase();
  const stageData = STAGE_IMAGES[userStage];

  stageContainer.innerHTML = '';
  if (!stageData) return;

  stageContainer.innerHTML = `
    <p class="custome-stage-heading">Ithe tumchyasarkhe koni tari aahe</p>
    <p class="custome-stage-subheading">${stageData.customerName} la Khatri navhti pan ti niyamit raahili."</p>
    <div class="stage-image-wrapper">
      ${stageData.images.map((imgUrl, i) => `
        <img src="${imgUrl}" alt="${userStage}" class="scrollable-stage-image" loading="lazy"/>
        ${i < stageData.images.length - 1 ? `<div class="stage-arrow">${STAGE_ARROW_SVG}</div>` : ''}
      `).join('')}
    </div>`;
}

// ─── PRICING ─────────────────────────────────────────────────────────────────

var prices = 0, variantsIDs = [];

function getProductByHandle(response) {
  let resultTotalPrice = document.querySelectorAll('.total-price');
  let strikeTotalPrice = document.querySelectorAll('.strike-cart-total-price');
  state.strikeFinalCartPrice = Math.round(response.newPriceCard.updatedCartPrice);

  if (strikeTotalPrice.length !== 0) {
    strikeTotalPrice.forEach((price) => { price.innerHTML = `₹ ${state.strikeFinalCartPrice + 500}`; });
  }
  const finalCartPrice = Math.round(response.cart_price);
  if (resultTotalPrice.length != 0) {
    resultTotalPrice.forEach((price) => { price.innerHTML = `₹ ${finalCartPrice}`; });
  }
  let pricePerDay = document.querySelector('.recommend-price-perday price-perday');
  if (pricePerDay) {
    const perDayPriceValue = Math.round(finalCartPrice / 30);
    pricePerDay.innerText = `${perDayPriceValue}`;
  }
  applyOneMonthDiscount(response);
}

// Function to determine if the device is mobile
function isMobileDevice() {
  return window.innerWidth <= 767;
}

document.querySelector('.product-combo-details').addEventListener('click', function(event) {
  if (event.target.closest('.product-remove-btn')) {
    return;
  }

  const reco = event.target.closest('.kit-card-container');
  if (reco) {
    const productId = reco.getAttribute('data-product-id');
    const productName = reco.getAttribute('data-product-name');
    productFireEvent("web_product_card_clicked", caseId, productName);
    createProductPopup(productId);
  }
});

// Function to create and display popup with product details
function createProductPopup(productId) {
  const popup = document.getElementById('product-popup');
  const overlay = document.getElementById('background-overlay');
  const popupContentPlaceholder = document.getElementById('popup-content-placeholder');
  const siteUrl = {
    dev: { 
      "Link": "formv2s.dev.hav-g.in"
    },
    prod: { 
      "Link": "form.traya.health"
    }
  };

  const iframeUrl = `https://${siteUrl.prod.Link}/product-drawerv2/${productId}`;
  popupContentPlaceholder.innerHTML = `
    <iframe src="${iframeUrl}" frameborder="0" width="100%" height="100%"></iframe>
  `;
  
  if (isMobileDevice()) {
    popup.style.bottom = '0';
  } else {
    popup.style.right = '0';
  }

  overlay.style.display = 'block';
  document.body.style.overflow = 'hidden';
  const closeIcon = document.getElementById('close-popup');
  closeIcon.addEventListener('click', function() {
    closeProductPopup();
  });
  overlay.addEventListener('click', function() {
    closeProductPopup();
  });
}

// Function to close the popup
function closeProductPopup() {
  const popup = document.getElementById('product-popup');
  const overlay = document.getElementById('background-overlay');
  
  if (isMobileDevice()) {
    popup.style.bottom = '-100%';
  } else {
    popup.style.right = '-100%';
  }

  overlay.style.display = 'none';
  document.body.style.overflow = '';
}

function applyOneMonthDiscount(response) {
  const discountsData = response?.discounts;
  if (!discountsData) return;
  if (!discountsData.discountValidityByPlan?._1Month) return;

  const discountObj = discountsData.discount?.[0];
  if (!discountObj) return;

  const { code, value, validCartValue } = discountObj;
  if (!code || !value || !validCartValue) return;

  const cartTotal = Math.round(response.cart_price);
  if (cartTotal < validCartValue) return;

  let discountAmount = 0;
  if (discountObj.type === 'percentage') {
    discountAmount = Math.round((cartTotal * value) / 100);
  } else {
    discountAmount = value;
  }

  const discountedTotal = Math.max(cartTotal - discountAmount, 0);
  const discountStrikeElement = document.querySelector('.strike-cart-total-price').innerHTML;
  const originalStrikePrice = discountStrikeElement.split(' ');
  const updatedStrikePrice = originalStrikePrice[1] - value;

  document.querySelectorAll('.strike-cart-total-price').forEach(el => { el.innerHTML = `₹ ${updatedStrikePrice}`; });
  document.querySelectorAll('.total-price').forEach(el => { el.innerHTML = `₹ ${discountedTotal}`; });
  document.querySelectorAll('.refferal-discount-applied').forEach(el => { el.classList.remove('d-none'); });

  window.appliedReferralCode = code;
}

// ─── POP ONE-LINER DATA ───────────────────────────────────────────────────────
// Single source of truth for canonical product names + variant IDs.
// The .product field here MUST match keys in PRODUCT_TRANSLATIONS_MR
// (via the includes() check in getProductMarathi).

const popOneLinerData = [
  {
    product: "Her Santulan",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/her_santulan_1f4b7e30-172b-4a88-8e98-a700d47fd4eb.webp?v=1773122932",
    productVariantId: "46466095906994",
    oneliner: "Her Santulan supports daily wellness to maintain healthy hair.",
    ingredientName: "Shatavari | Brahmi",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Shatavari.webp?v=1770375027 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Brahmi.webp?v=1770375027",
    ingredientContent: "Shatavari helps balance internal heat and hormones, which in turn helps promote healthy hair. | Calms scalp stress response, supporting healthier follicle activity and reduced hair fall.",
  },
  {
    product: "Mom Santulan for Postpartum hair",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/mom_santulan_3c406b34-dfbe-4ecc-a615-e2e2ec9f32fc.webp?v=1773122932",
    productVariantId: "46466402779314",
    oneliner: "Mom Santulan helps reduce post-partum hair fall.",
    ingredientName: "Vidarikand | Lodhra",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Vidarikand.webp?v=1770375187 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Lodhra.webp?v=1770375186",
    ingredientContent: "Nourishes hair roots by supporting hormonal balance and tissue strength. | Helps balance scalp oiliness and supports a healthier follicle environment.",
  },
  {
    product: "Iron Santulan",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/iron_santulan_7813afaa-5414-4107-9b80-a1be43b00b63.webp?v=1773122932",
    productVariantId: "46465792704690",
    oneliner: "Iron Santulan helps reduce hair fall caused by anemia.",
    ingredientName: "Navayasa Loh | Pippali",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Navayasa.webp?v=1770375340 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Pippali.png?v=1770375365",
    ingredientContent: "Helps correct iron-related deficiencies that contribute to excessive hair fall. | Improves metabolism and circulation, helping nutrients reach hair follicles efficiently.",
  },
  {
    product: "Thyro Santulan",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/thyro_santulan_03953df7-f945-40c0-896b-edf7521ba888.webp?v=1773122932",
    productVariantId: "46466225438898",
    oneliner: "Thyro Santulan helps reduce hair fall caused by thyroid issues.",
    ingredientName: "Chandraprabha Vati | Triphala",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Chandraprabhavati.png?v=1770375642 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Triphala.png?v=1758868752",
    ingredientContent: "Supports hormonal balance and metabolic health, helping reduce internally triggered hair fall. | Supports detox and nutrient absorption for healthier hair growth",
  },
  {
    product: "Gut Shuddhi",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/gutt_shuddhi_81469b73-b40c-4d07-b98e-9fc5f364c177.webp?v=1773122932",
    productVariantId: "46528902496434",
    oneliner: "Gut Shuddhi supports digestion to help reduce hair fall.",
    ingredientName: "Amla | Sunth",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/amla.webp?v=1770375815 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Sunth.webp?v=1770375802",
    ingredientContent: "Rich in antioxidants, strengthens hair roots and supports hair growth. | Enhances blood flow and nutrient delivery to support healthy hair growth.",
  },
  {
    product: "Digest boost for Improved Digestive Ability",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/digest_boost_7ac2e221-36b5-4c74-9c62-9220d8d707b7.webp?v=1773122932",
    productVariantId: "46528963936434",
    oneliner: "Digest Boost supports digestion to help reduce hair fall.",
    ingredientName: "Variyali | Ganthoda",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Variyali.webp?v=1770376077 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/ganthoda.webp?v=1770376091",
    ingredientContent: "Improves digestion and reduces internal heat, supporting healthier hair growth from within. | Boosts circulation and digestion, supporting nourishment to hair follicles.",
  },
  {
    product: "Health Tatva",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/health_tatva_8fbfa017-240b-476b-9941-082f4f69156c.webp?v=1773122932",
    productVariantId: "47276523749554",
    oneliner: "Health Tatva helps in boosting metabolism.",
    ingredientName: "Sunth | Pippali",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Sunth.webp?v=1770375802 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Pippali.png?v=1770375365",
    ingredientContent: "Improves blood circulation and digestion, helping nutrients reach hair follicles effectively. | Improves metabolism and circulation, helping nutrients reach hair follicles efficiently.",
  },
  {
    product: "Hair Vitamin for her",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/hair_vitamin_her.webp?v=1773122933",
    productVariantId: "47303097352370",
    oneliner: "Hair Vitamin addresses nutritional deficiency to reduce hair fall.",
    ingredientName: "Biotin | Amino Acids",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Biotin.webp?v=1770376883 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Amino_Acids.webp?v=1770376900",
    ingredientContent: "Supports keratin production, helping strengthen hair and reduce breakage. | Build keratin structure, improving hair strength, thickness, and resistance to breakage.",
  },
  {
    product: "Hair Vitamin",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/hair_vitamin_4b815fc7-1797-4776-aee7-08d81b7910fa.webp?v=1773122933",
    productVariantId: "47303072710834",
    oneliner: "Hair Vitamin addresses nutritional deficiency to reduce hair fall.",
    ingredientName: "Biotin | Pumpkin Seed Extract",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Biotin.webp?v=1770376883 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Pumpkin_Seed_Extract.png?v=1758868752",
    ingredientContent: "Supports keratin production, helping strengthen hair and reduce breakage. | Helps block DHT activity, supporting reduced hair thinning.",
  },
  {
    product: "Calm Ras",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/calm_ras_b430a71f-5841-475c-b4fa-7e8008b124cd.webp?v=1773122932",
    productVariantId: "47276517195954",
    oneliner: "Calm Ras helps to reduce hair fall caused by stress.",
    ingredientName: "Ashwagandha | Brahmi",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Ashwagandha.webp?v=1770377173 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Brahmi.webp?v=1770375027",
    ingredientContent: "Ashwagandha helps reduce stress and encourages blood circulation in the scalp, thereby encouraging hair growth. | Prolongs hair growth phase and strengthens roots, supporting thicker and healthier hair regrowth.",
  },
  {
    product: "Nasal Ghrit",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/ghrit.webp?v=1773122932",
    productVariantId: "47276533121202",
    oneliner: "Nasal Ghrit promotes better sleep to help reduce hair fall.",
    ingredientName: "Cow Ghee | Shatavari",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Cow_Ghee_1.png?v=1758868752 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Shatavari.webp?v=1770375027",
    ingredientContent: "Deeply moisturizes scalp and supports repair of dry, brittle hair shafts. | Supports hormonal balance and nourishment of hair follicles in women.",
  },
  {
    product: "Hair Ras",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/hair_ras_e242cfaf-dd81-44a7-ba77-21f4004a73b6.webp?v=1773122932",
    productVariantId: "46528906821810",
    oneliner: "Hair Ras provides essential nourishment for stronger, healthier hair.",
    ingredientName: "Ashwagandha | Bringhraj",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Ashwagandha.webp?v=1770377173 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Bhringraj.webp?v=1770379802",
    ingredientContent: "Ashwagandha helps reduce stress and encourages blood circulation in the scalp, thereby encouraging hair growth. | Reduces stress hormones and improves scalp nourishment, helping control stress-related hair fall.",
  },
  {
    product: "Anti-Dandruff Shampoo",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/anti_dandruff_shampoo_e51702d8-80e1-4ffb-b331-88c837162493.webp?v=1773122932",
    productVariantId: "47329496826034",
    oneliner: "Anti-Dandruff Shampoo fights dandruff to help reduce hair fall.",
    ingredientName: "Ketocanozole 2% | AleoVera",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Anti-dandruff_keto.webp?v=1770380073 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/aloe_vera.webp?v=1770296912",
    ingredientContent: "Reduces dandruff-causing fungus and scalp inflammation linked to hair loss. | Helps reduce scalp dryness and flaking that can weaken hair roots.",
  },
  {
    product: "Recap Serum",
    productImage: "",
    productVariantId: "41645770309810",
    oneliner: "Recap Serum supports hair regrowth for fuller, healthier hair.",
    ingredientName: "",
    ingredientImage: "",
    ingredientContent: "",
  },
  {
    product: "Ketoconazole 2% night lotion",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/anti_dandruff_night_lotion.webp?v=1773122932",
    productVariantId: "46528923304114",
    oneliner: "Night Lotion fights dandruff to help reduce hair fall.",
    ingredientName: "Ketocanozole 2% | AleoVera",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Anti-dandruff_keto.webp?v=1770380073 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/aloe_vera.webp?v=1770296912",
    ingredientContent: "Reduces dandruff-causing fungus and scalp inflammation linked to hair loss. | Soothes irritated scalp and supports moisture balance for healthier hair growth.",
  },
  {
    product: "Scalp Oil 100ml with Dandruff Oil Shot",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/scalp_oil_100ml_dandruff_oil_shot_75ba5254-6e4d-4ab4-9b9d-813b82200be1.webp?v=1773122932",
    productVariantId: "46530320040114",
    oneliner: "Scalp Oil nurtures scalp health to support stronger hair.",
    ingredientName: "Camphor | Castor oil",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Camphor.webp?v=1770380600 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/CastorOil.webp?v=1770297142",
    ingredientContent: "Improves scalp circulation and helps relieve itchiness linked to hair fall. | Nourishes scalp and supports thicker-looking hair by strengthening strands.",
  },
  {
    product: "Scalp Oil 100ml with Scalp Health Oil Shot",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/scalp_oil_50ml_scalp_shot.webp?v=1773122932",
    productVariantId: "46531529638066",
    oneliner: "Scalp Oil nurtures scalp health to support stronger hair.",
    ingredientName: "Bergamot | ORPL",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/bergamot.webp?v=1770380916 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/ORPL.webp?v=1770380916",
    ingredientContent: "Helps balance oily scalp and supports a healthier scalp environment. | Helps improve hair fibre strength and reduces breakage from daily stress.",
  },
  {
    product: "Scalp Oil 100ml with Calm Oil Shot",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/scalp_oil_100ml_calm_oil_shot_222213c0-d57b-403f-9472-29fc8caa5408.webp?v=1773122932",
    productVariantId: "46530283012274",
    oneliner: "Scalp Oil nurtures scalp health to support stronger hair.",
    ingredientName: "Coconut Oil | Amla",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Property_13.webp?v=1770381512 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/amla.webp?v=1770375815",
    ingredientContent: "Penetrates hair shaft to reduce protein loss and strengthen strands. | Rich in antioxidants, strengthens hair roots and supports hair density.",
  },
  {
    product: "Scalp Oil 100ml with Growth Oil Shot",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/scalp_oil_100ml_growth_shot.webp?v=1773122932",
    productVariantId: "46530384527538",
    oneliner: "Scalp Oil nurtures scalp health to support stronger hair.",
    ingredientName: "Camphor | Wheat Germ",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Camphor.webp?v=1770380600 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Property_14.webp?v=1770381631",
    ingredientContent: "Improves scalp circulation and helps relieve itchiness linked to hair fall. | Rich in vitamin E, supports scalp nourishment and hair strength.",
  },
  {
    product: "Nourish hair oil",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/nourish_hair_oil_314b3a0e-62e9-439b-896d-e97653385eb0.webp?v=1773122933",
    productVariantId: "47302951403698",
    oneliner: "Nourish Oil deeply nourishes hair for strength and shine.",
    ingredientName: "Argan Oil | Rosemary Extract",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/ArganOil.webp?v=1770297123 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Rosemary_Oil.png?v=1758868752",
    ingredientContent: "Rich in fatty acids, improves hair elasticity and reduces breakage. | Improves scalp circulation and supports thicker hair growth.",
  },
  {
    product: "Her Nourish",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/her_nourish.webp?v=1773129965",
    productVariantId: "47302857621682",
    oneliner: "Protects hair from harmonal hair fall",
    ingredientName: "Deodar | Latakranj",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Deodar.webp?v=1770616150 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Latakranj.webp?v=1770616191",
    ingredientContent: "Helps reduce scalp inflammation and microbial buildup that can weaken hair roots. | Traditionally used to support hair pigmentation and reduce premature greying.",
  },
  {
    // ✅ Canonical name matches the PRODUCT_TRANSLATIONS_MR key exactly.
    // bundleMap uses "Shine serum" — that mismatch is fixed by looking this
    // entry up via variantId and using product field for the Marathi lookup.
    product: "Shine Leave in Serum",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/shine_serum_7a3e136e-3b42-4c9b-87c7-dfc7d17aaac4.webp?v=1773122932",
    productVariantId: "47301148803250",
    oneliner: "Shine Serum enhances hair texture for a vibrant, healthy look.",
    ingredientName: "Dimethicone",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Dimethicone.webp?v=1770616417",
    ingredientContent: "Forms a protective layer to smooth hair and reduce friction-related breakage.",
  },
  {
    product: "Defence Shampoo",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/defence_shampoo_180ml_d8c40ac4-8f71-4272-9bae-ec8aca8d51c1.webp?v=1773122932",
    productVariantId: "47301151064242",
    oneliner: "Defence Shampoo ensures hair hygiene for a healthy scalp.",
    ingredientName: "Vitamin B3 | Biotin",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Vitamin_B3.webp?v=1770616654 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Biotin.webp?v=1770376883",
    ingredientContent: "Improves scalp blood circulation, supporting healthier hair follicles. | Supports keratin production, helping improve hair strength and thickness.",
  },
  {
    product: "Defence Conditioner",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/defence_conditioner_a7689873-6f78-4fdf-8db9-751502e1ae80.webp?v=1773122932",
    productVariantId: "44650256728242",
    oneliner: "Defence conditioner improves hair quality by deeply moisturizing the hair strands",
    ingredientName: "Biotin | Hydrolysed Rice protein",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Biotin.webp?v=1770376883 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Hydrolysed_Rice_protein.webp?v=1770616808",
    ingredientContent: "Supports keratin production, helping strengthen hair and reduce breakage. | Strengthens hair strands, improves elasticity, and reduces breakage.",
  },
  {
    product: "Defence Conditioner 50g",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/defenceConditioner50mg1.webp?v=1743657581",
    productVariantId: "45277154377906",
    oneliner: "Defence conditioner improves hair quality by deeply moisturizing the hair strands",
    ingredientName: "Biotin | Hydrolysed Rice protein",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Biotin.webp?v=1770376883 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Hydrolysed_Rice_protein.webp?v=1770616808",
    ingredientContent: "Supports keratin production, helping strengthen hair and reduce breakage. | Strengthens hair strands, improves elasticity, and reduces breakage.",
  },
  {
    product: "Consti Clear for Improved Bowel Movement",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/consti_clear_6c553d57-1fe9-4eae-9afd-4613f4a28194.webp?v=1773122933",
    productVariantId: "47276511199410",
    oneliner: "Consti clear supports digestion to help reduce hair fall.",
    ingredientName: "",
    ingredientImage: "",
    ingredientContent: "",
  },
  {
    product: "Minoxidil 2%",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/minoxidil_2_cd28309f-2f80-465f-97d4-68f21c8eba54.webp?v=1773122932",
    productVariantId: "47329517568178",
    oneliner: "Minoxidil 2% promotes hair regrowth for thicker, fuller hair.",
    ingredientName: "Minoxidil 2% | Procapil 2%",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Minoxidil_2ing.webp?v=1770380305 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Procapil_2.webp?v=1770380316",
    ingredientContent: "Stimulates inactive follicles to support visible hair regrowth in early hair thinning. | Helps slow hair follicle ageing and supports reduced hair fall.",
  },
  {
    product: "Minoxidil 5%",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/minoxidil_5_39c0bb5f-6a2a-43c2-959e-c846a47b31a0.webp?v=1773122932",
    productVariantId: "47302891929778",
    oneliner: "Minoxidil 5% alcohol free promotes hair regrowth for thicker, fuller hair.",
    ingredientName: "Minoxidil 5% | Procapil 3%",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Minoxidil_2ing.webp?v=1770380305 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Procapil_2.webp?v=1770380316",
    ingredientContent: "Strongly activates follicles to promote denser, faster hair regrowth. | Helps slow hair follicle ageing and supports reduced hair fall.",
  },
  {
    product: "Minoxidil 5% alc free",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/minoxidil_finasteride_5__alcoholfree.webp?v=1773122932",
    productVariantId: "46465512898738",
    oneliner: "Minoxidil 5% alcohol free promotes hair regrowth for thicker, fuller hair.",
    ingredientName: "Minoxidil 5% | Procapil 3%",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Minoxidil_2ing.webp?v=1770380305 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Procapil_2.webp?v=1770380316",
    ingredientContent: "Strongly activates follicles to promote denser, faster hair regrowth. | Helps slow hair follicle ageing and supports reduced hair fall.",
  },
  {
    product: "Minoxidil 2% alc free",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/minoxidil_finasteride_2__alcoholfree.webp?v=1773122932",
    productVariantId: "47276531417266",
    oneliner: "Minoxidil 2% alcohol free promotes hair regrowth for thicker, fuller hair.",
    ingredientName: "Minoxidil 2% | Procapil 2%",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Minoxidil_2ing.webp?v=1770380305 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Procapil_2.webp?v=1770380316",
    ingredientContent: "Stimulates inactive follicles to support visible hair regrowth in early hair thinning. | Helps slow hair follicle ageing and supports reduced hair fall.",
  },
  {
    product: "Hair Santulan 01",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/her_santulan01.webp?v=1773122932",
    productVariantId: "47302996394162",
    oneliner: "Hair Santulan is customized to target internal root causes of your hair fall",
    ingredientName: "Bhringraj | Shatavari",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Bhringraj_1.webp?v=1770626930 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Shatavari.webp?v=1770375027",
    ingredientContent: "Bhringraj prevents hair thinning and keeps the scalp free of dandruff and excess grease. | Supports hormonal balance and follicle nourishment, helping reduce female-pattern hair thinning.",
  },
  {
    product: "Hair Santulan 02",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/her_santulan02.webp?v=1773122933",
    productVariantId: "47446793879730",
    oneliner: "Hair Santulan is customized to target internal root causes of your hair fall",
    ingredientName: "Amalki | Bhringraj",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/amla.webp?v=1770375815 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Bhringraj_1.webp?v=1770626930",
    ingredientContent: "supports collagen production and strengthens hair follicles at the root. | Nourishes hair roots and supports longer, stronger hair growth.",
  },
  {
    product: "Hair Santulan 03",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/her_santulan03.webp?v=1773122933",
    productVariantId: "47303079166130",
    oneliner: "Hair Santulan is customized to target internal root causes of your hair fall",
    ingredientName: "Amalki | Bhringraj",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/amla.webp?v=1770375815 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Bhringraj_1.webp?v=1770626930",
    ingredientContent: "supports collagen production and strengthens hair follicles at the root. | Nourishes hair roots and supports longer, stronger hair growth.",
  },
  {
    product: "Hair Active Serum",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Hair_Actives.webp?v=1773122932",
    productVariantId: "47300731568306",
    oneliner: "Hair Active Serum prevents hair thinning for fuller, healthier hair.",
    ingredientName: "3% Redensyl | 2% capixyl",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Redensyl.webp?v=1770627288 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Dimethicone.webp?v=1770616417",
    ingredientContent: "Activates hair follicles to support faster, denser hair regrowth. | Helps reduce hair fall and supports thicker, stronger hair regrowth.",
  },
  {
    product: "Hair Ras 01",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/hair_ras01.webp?v=1773122932",
    productVariantId: "47302757875890",
    oneliner: "Hair Ras is customized to target internal root causes of your hair fall.",
    ingredientName: "Amalki | Bhringraj",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/amla.webp?v=1770375815 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Bhringraj_1.webp?v=1770626930",
    ingredientContent: "Improves hair strength and supports natural hair growth. | Nourishes hair roots and supports longer, stronger hair growth.",
  },
  {
    product: "Hair Ras 02",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/hair_ras02.webp?v=1773122932",
    productVariantId: "47301161091250",
    oneliner: "Hair Ras is customized to target internal root causes of your hair fall.",
    ingredientName: "Bhringraj | Guduchi",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Bhringraj_1.webp?v=1770626930 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Property_19.webp?v=1770627488",
    ingredientContent: "Nourishes the scalp and supports stronger, longer hair growth. | Reduces inflammation and supports scalp and hair follicle health.",
  },
  {
    product: "Hair Ras 05",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/hair_ras05.webp?v=1773122932",
    productVariantId: "46464896630962",
    oneliner: "Hair Ras is customized to target internal root causes of your hair fall.",
    ingredientName: "Amalki | Iron Bhasma",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/amla.webp?v=1770375815 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Iron_Bhasma.webp?v=1770627628",
    ingredientContent: "supports collagen production and strengthens hair follicles at the root. | Helps correct iron deficiency, supporting healthy hair growth from within.",
  },
  {
    product: "Hair Ras 06",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/hair_ras06.webp?v=1773122932",
    productVariantId: "47301139169458",
    oneliner: "Hair Ras is customized to target internal root causes of your hair fall.",
    ingredientName: "Shatavari | Brahmi",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Shatavari.webp?v=1770375027 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Brahmi.webp?v=1770375027",
    ingredientContent: "Shatavari helps balance internal heat and hormones, which in turn helps promote healthy hair. | Reduces stress hormones and supports scalp nourishment, helping control stress-related hair fall.",
  },
  {
    product: "Hair Ras 09",
    productImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/hair_ras09.webp?v=1773122932",
    productVariantId: "46464745308338",
    oneliner: "Hair Ras is customized to target internal root causes of your hair fall.",
    ingredientName: "Ashwagandha | Amalki",
    ingredientImage: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Ashwagandha.webp?v=1770377173 | https://cdn.shopify.com/s/files/1/0100/1622/7394/files/amla.webp?v=1770375815",
    ingredientContent: "Ashwagandha helps reduce stress and encourages blood circulation in the scalp, thereby encouraging hair growth. | Boosts collagen synthesis and antioxidant protection, strengthening hair follicles at the root.",
  }
];

// ─── INGREDIENT LOOKUP ───────────────────────────────────────────────────────

function getIngredientData(variantId) {
  return popOneLinerData.find(item => item.productVariantId === variantId);
}

// ─── RENDER PRODUCT CARD ─────────────────────────────────────────────────────
// FIX: look up canonical name from popOneLinerData by variantId FIRST, then
// pass that canonical name to getProductMarathi.
// e.g. bundleMap has "Shine serum" but popOneLinerData has "Shine Leave in Serum"
// — the variantId 47301148803250 bridges the gap reliably.

function renderProductCard(product, usageOneLiner = '') {
  const caseId = state.caseId;
  const valiedChatCase = caseId && /^[0-7]/.test(caseId);

  const mobileProductData = popOneLinerData.find(
    item => String(item.productVariantId) === String(product.product_id)
  );

  const oneLinerText = product.oneLiner || product.one_liner || product.oneliner || mobileProductData?.oneliner || '';

  // ✅ KEY FIX: use canonical name from popOneLinerData, fall back to product.name
  const canonicalName = mobileProductData?.product || product.name;
  const marathi = getProductMarathi(canonicalName, oneLinerText);

  const mobileProductImage = mobileProductData?.productImage || product.image_url?.singleImage || product.image_url;
  const ingredientData = getIngredientData(product.product_id);

  let ingredientsHTML = '';
  if (ingredientData && ingredientData.ingredientName) {
    const names = ingredientData.ingredientName.split('|');
    const images = ingredientData.ingredientImage.split('|');
    ingredientsHTML = names.map((name, i) => `
      <div class="ingredient-item">
        <div class="ingredient-img">
          <img src="${images[i].trim()}" loading="lazy"/>
        </div>
        <p>${name.trim()}</p>
      </div>
    `).join('');
  }

  const desktopHTML = `
  <!-- DESKTOP -->
  <div class="reco-pro reco-product-combo remove-cart-experiment">
    <div class="box-separator-line">
      <div class="hairthinning-combo-kit-wrapper">
        ${product.product_id === "45277154377906" || product.product_id === "47084348309682" ?
          `<div class="free-product-badge">
            <img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/free_product_gift.webp?v=1743688549" alt="Free Product Tag" width="24px" height="24px" loading="lazy" class="p-image"/>
            <p class="free-gift-product">He tumchyasathi ek "MUPHAT" bhet ahe.</p>
          </div>` : ''}
        <div class="hairthinning-combo-kit-container">
          <div class="p-image-container">
            <img src="${product.image_url.singleImage}" width="100" height="100"/>
          </div>
          <div class="prod-content-wrapper">
            <div class="p-content-container">
              <h2 class="p-title">${marathi.title}</h2>
              <p class="liner-text">${marathi.description}</p>
              <div class="p-price-container d-flex">
                <p class="p-price">
                  ${
                    product.product_id === "45277154377906"
                      ? `<del>₹199</del>`
                      : product.product_id === "47084348309682"
                      ? `<del>₹267</del>`
                      : product.originalPrice
                      ? `<del>₹${Math.floor(product.originalPrice)}</del> ₹${Math.floor(product.price)}`
                      : `₹${Math.floor(product.price)}`
                  }
                </p>
              </div>
            </div>
          </div>
          <div class="remove-icon-container">
            <div class="arrow-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none">
                <path d="M6.5306 7.03062L1.5306 12.0306C1.3897 12.1715 1.19861 12.2507 0.999348 12.2507C0.80009 12.2507 0.608994 12.1715 0.468098 12.0306C0.327201 11.8897 0.248047 11.6986 0.248047 11.4994C0.248047 11.3001 0.327201 11.109 0.468098 10.9681L4.93747 6.5L0.469348 2.03062C0.399583 1.96086 0.344243 1.87804 0.306486 1.78689C0.26873 1.69573 0.249297 1.59804 0.249297 1.49937C0.249297 1.40071 0.26873 1.30302 0.306486 1.21186C0.344243 1.12071 0.399583 1.03789 0.469348 0.968125C0.539113 0.89836 0.621936 0.843019 0.713088 0.805263C0.80424 0.767507 0.901936 0.748074 1.0006 0.748074C1.09926 0.748074 1.19696 0.767507 1.28811 0.805263C1.37926 0.843019 1.46208 0.89836 1.53185 0.968125L6.53185 5.96812C6.60169 6.03788 6.65707 6.12074 6.69481 6.21195C6.73256 6.30316 6.75193 6.40092 6.75181 6.49963C6.7517 6.59834 6.7321 6.69606 6.69414 6.78718C6.65617 6.8783 6.6006 6.96103 6.5306 7.03062Z" fill="black"/>
              </svg>
            </div>
            ${product.product_id === "45277154377906" || product.product_id === "47084348309682" ?
              `<div class="product-remove-btn" data-variant-id="${product.product_id}" data-product-name="${product.name}" data-product-image="${product.image_url.singleImage}">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M2.5 5.00033H17.5M15.8333 5.00033V16.667C15.8333 17.5003 15 18.3337 14.1667 18.3337H5.83333C5 18.3337 4.16667 17.5003 4.16667 16.667V5.00033M6.66667 5.00033V3.33366C6.66667 2.50033 7.5 1.66699 8.33333 1.66699H11.6667C12.5 1.66699 13.3333 2.50033 13.3333 3.33366V5.00033" stroke="#262626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>` : ''}
          </div>
        </div>
      </div>
    </div>
  </div>`;

  let mobileHTML = '';
  if (valiedChatCase) {
    mobileHTML = `
    <!-- MOBILE EXPERIMENT -->
    <div class="mobile-product-card d-flex d-md-none">
      <div class="mobile-product-image--wrapper">
        ${product.product_id != "45277154377906" ?
          `<div class="product-remove-btn" data-variant-id="${product.product_id}" data-product-name="${product.name}" data-product-image="${product.image_url.singleImage}">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M2.5 5.00033H17.5M15.8333 5.00033V16.667C15.8333 17.5003 15 18.3337 14.1667 18.3337H5.83333C5 18.3337 4.16667 17.5003 4.16667 16.667V5.00033M6.66667 5.00033V3.33366C6.66667 2.50033 7.5 1.66699 8.33333 1.66699H11.6667C12.5 1.66699 13.3333 2.50033 13.3333 3.33366V5.00033" stroke="#262626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>` : ''}
        <div class="mobile-product-image">
          <img src="${mobileProductImage}" loading="lazy"/>
        </div>
      </div>
      <div class="mobile-product-content--wrapper">
        <h3 class="result-product-title">${marathi.title}</h3>
        <div class="mobile-price">₹${Math.floor(product.price)}</div>
        <p class="mobile-oneliner">${marathi.description}</p>
        <hr>
        ${ingredientsHTML ? `
        <div class="mobile-ingredients">
          <p class="ingredients-title">Key Ingredients</p>
          <div class="ingredients-flex">${ingredientsHTML}</div>
        </div>` : ''}
        <div class="mobile-more-details">More Details ›</div>
      </div>
    </div>`;
  }

  return desktopHTML;
}

// ─── PRODUCT COMBO KIT ───────────────────────────────────────────────────────

function productComboKit(response) {
  const productData = response.product_Ids;
  let proDetEle = document.querySelector('.product-combo-details');
  proDetEle.innerHTML = '';
  const caseId = state.caseId;
  const valiedChatCase = caseId && /^[0-7]/.test(caseId);

  document.body.classList.add('control-user');

  const header = document.createElement('h2');
  header.classList.add('kit-header', 'section-heading-font');
  header.innerText = 'Month 1 Doctor-Prescribed Kit';

  if (window.innerWidth <= 767) {
    // mobile: no container class
  }

  const matchingExtraData = response.extraDataForProducts.find((extra) => {
    return extra.productId === response.product_Ids[index].product_id;
  });

  let usageOneLiner = matchingExtraData?.howToUseData?.usage_one_liner || '';

  const fragment = document.createDocumentFragment();
  productData.forEach((each) => {
    const productDiv = document.createElement('div');
    productDiv.classList.add('kit-card-container');
    productDiv.dataset.productId = each.product_id;
    productDiv.dataset.productName = each.name;
    productDiv.innerHTML = renderProductCard(each, usageOneLiner);
    fragment.appendChild(productDiv);

    if (getCookie("GuestForm_id")) {
      variantsIDs.push({ 'id': each.product_id, 'quantity': 1, properties: { '_result_id': id } });
    } else {
      variantsIDs.push({ 'id': each.product_id, 'quantity': 1 });
    }
  });

  proDetEle.appendChild(fragment);

  const removedProducts = [];
  let selectedVariantId = null;
  let selectedProductElement = null;

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.product-remove-btn');
    if (!btn) return;
    const productName = btn.getAttribute('data-product-name');
    const productImage = btn.getAttribute('data-product-image');
    selectedVariantId = btn.getAttribute('data-variant-id');
    updateRemovePopupContentByProduct(productName, productImage, selectedVariantId);
    selectedProductElement = document.querySelector(`.kit-card-container[data-product-id="${selectedVariantId}"]`);
    fireEvent("delete_product_clicked", caseId, selectedVariantId, productName);
    document.getElementById('remove-confirmation-popup').classList.add('popup-visible');
  });

  document.querySelector('.remove-popup-remove-btn').addEventListener('click', async function () {
    if (!selectedVariantId) return;
    const removeBtn = this;
    removeBtn.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/tube-spinner_3.svg?v=1741241123" class="loader-icon" alt="Loading..." style="width: 20px; height: 20px;" />`;

    try {
      const cart = await fetch('/cart.js').then(res => res.json());
      const lineItem = cart.items.find(item => item.variant_id == selectedVariantId);
      if (!lineItem) return;

      await removeCartItemByKey(lineItem.key);

      selectedProductElement.classList.add('fade-out');
      setTimeout(() => {
        selectedProductElement.remove();
        const removedFromKit = bundleMap.bundle1.find(p => p.variantId === selectedVariantId);
        if (removedFromKit) {
          restoreProductToOptionalList(removedFromKit, response);
          removeBtn.innerHTML = `Remove`;
        }
      }, 300);

      if (!removedProducts.includes(selectedVariantId)) {
        removedProducts.push(selectedVariantId);
        const removedProduct = productData.find(p => p.product_id === selectedVariantId);
        if (removedProduct) { renderRemovedProductCard(removedProduct); removeBtn.innerHTML = `Remove`; }
      }

      document.getElementById('remove-confirmation-popup').classList.remove('popup-visible');

      const updatedCart = await fetch('/cart.js').then(res => res.json());
      if (updatedCart.items.length === 1) {
        showCartAlmostEmptyPopup();
        document.querySelectorAll('.kit-card-container').forEach(card => card.remove());
      }
      updateStrikePriceAfterRemoval(response, selectedVariantId);
    } catch (err) { console.error('Error during removal:', err); }
  });

  function showCartAlmostEmptyPopup() {
    // Fetch cart state first to avoid calling clear.js on an already-empty cart.
    // Excessive clear.js calls on empty carts trigger Cloudflare bot detection on Shopify's CDN.
    fetch('/cart.js').then(r => r.json()).then(cartState => {
      if ((cartState.item_count || 0) > 0) fetch('/cart/clear.js');
    });
    const popup = document.getElementById('remove-confirmation-popup');
    const popupBox = popup.querySelector('.remove-popup-box');
    if (popup && popupBox) {
      popupBox.innerHTML = `
        <div class="remove-popup-flex">
          <h2 class="empty-cart-title">Your Cart is Empty</h2>
          <p class="empty-cart-msg">You have removed all products in your kit!</p>
        </div>
        <button class="go-back-btn" style="margin-top: 20px;" onclick="window.location.href = window.location.href;">Go Back To Original Cart</button>`;
      popup.style.display = 'flex';
      popup.classList.add('popup-visible');
      document.body.style.overflow = 'hidden';
    }
  }

  document.addEventListener('click', async function (e) {
    if (e.target.classList.contains('add-removed-to-cart-btn')) {
      const variantId = e.target.getAttribute('data-variant-id');
      e.target.disabled = true;
      e.target.classList.add('disabled');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      })
        .then(r => r.json())
        .then(() => {
          updateCartDrawer();
          const idx = removedProducts.indexOf(variantId);
          if (idx > -1) removedProducts.splice(idx, 1);
          const restoredProduct = productData.find(p => p.product_id === variantId);
          if (!restoredProduct) return;
          fireEvent("add_back", caseId, restoredProduct.product_id, restoredProduct.name);
          const productDiv = document.createElement('div');
          productDiv.classList.add('kit-card-container', 'fade-in');
          productDiv.dataset.productId = restoredProduct.product_id;
          productDiv.dataset.productName = restoredProduct.name;
          productDiv.innerHTML = renderProductCard(restoredProduct, restoredProduct.usageOneLiner);
          const proDetEle = document.querySelector('.product-combo-details');
          if (proDetEle) setTimeout(() => { proDetEle.appendChild(productDiv); }, 50);
          e.target.closest('.removed-product')?.remove();
          if (document.querySelectorAll('.removed-product').length === 0) {
            document.querySelector('.removed-products-flex').classList.add('d-none');
          }
          updateStrikePriceAfterAddition(response, variantId);
        })
        .catch(err => console.error('Error:', err));
    }
  });

  document.querySelector('.remove-popup-keep-btn').addEventListener('click', function () {
    selectedProductElement = null;
    selectedVariantId = null;
    document.getElementById('remove-confirmation-popup').classList.remove('popup-visible');
  });

  const popupOverlay = document.getElementById("remove-confirmation-popup");
  if (popupOverlay) {
    popupOverlay.addEventListener("click", function (e) {
      const popupBox = document.querySelector(".remove-popup-box");
      if (!popupBox.contains(e.target)) document.querySelector(".remove-popup-keep-btn")?.click();
    });
  }
}

// ─── BUNDLE MAP ──────────────────────────────────────────────────────────────

const bundleMap = {
  bundle1: [
    { "variantId": "47301151064242", "name": "Defence Shampoo", "image_url": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Product_1_86e4caf1-109f-4f35-a88c-3bc4b35e869c.webp?v=1763373344", "one_liner": "Hydrates Deeply and Reduces Dryness", "tag": "Scalp swachh karte", "price": "267.00", "originalPrice": "300" },
    { "variantId": "44650256728242", "name": "Defence conditioner", "image_url": "https://dvv8w2q8s3qot.cloudfront.net/products/product_single_images/defenceConditioner50mg1.png", "one_liner": "Conditions and Smoothens Hair Texture", "tag": "Kes mou karte", "price": "320.00" },
    { "variantId": "46528923304114", "name": "Anti Dandruff Lotion", "image_url": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Anti_Dandruff_Solution.webp?v=1765353677", "one_liner": "Night Lotion fights dandruff to help reduce hair fall.", "tag": "Konda kadhun taka", "price": "355.00", "originalPrice": "399" },
    { "variantId": "47303097352370", "name": "Hair vitamin for her", "image_url": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Property.webp?v=1766144058", "one_liner": "Supplements to meet Hair's Nutrition needs.", "tag": "Kesannmadhe chamak anto", "price": "463.00", "originalPrice": "520" },
    // "Shine serum" here is the raw/display name; Marathi is resolved via variantId → popOneLinerData
    { "variantId": "47301148803250", "name": "Shine serum", "image_url": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/shine_leave_in_serum.webp?v=1771394293", "one_liner": "Shine Serum enhances hair texture for a vibrant, healthy look.", "tag": "Kesannmadhe chamak anto", "price": "599.00" },
    { "variantId": "47329496826034", "name": "Anti-Dandruff Shampoo", "image_url": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Anti_Dandruff_Shampoo2.webp?v=1765353725", "one_liner": "Anti-Dandruff Shampoo fights dandruff to help reduce hair fall.", "tag": "Konda kadhun taka", "price": "281.00", "originalPrice": "300" }
  ]
};

// ─── OPTIONAL ADD-ON PRODUCTS ─────────────────────────────────────────────────
// FIX: resolve canonical name via popOneLinerData before Marathi lookup

function optionalAddOnProducts(response) {
  const productCardContainers = document.querySelector(".optional-add-ons-wrapper");
  const optionalProductBundle = bundleMap['bundle1'];
  const responseProductData = response.product_Ids;
  const excludedIds = new Set(["44650256728242"]);
  const caseId = state.caseId;
  const existingVariantIds = new Set(
    responseProductData.map(p => String(p.product_id)).filter(id => !excludedIds.has(id))
  );
  if (!optionalProductBundle) return;
  document.querySelector('.optional-add-ons-section').classList.remove('d-none');

  const fragment = document.createDocumentFragment();
  optionalProductBundle.forEach((optionalProduct) => {
    if (existingVariantIds.has(optionalProduct.variantId)) return;

    // ✅ KEY FIX: resolve canonical name via variantId lookup
    const popData = popOneLinerData.find(
      item => String(item.productVariantId) === String(optionalProduct.variantId)
    );
    const canonicalName = popData?.product || optionalProduct.name;
    const marathi = getProductMarathi(canonicalName, optionalProduct.one_liner);

    const productDiv = document.createElement('div');
    productDiv.classList.add('optional-add-ons-list');
    productDiv.dataset.productId = optionalProduct.variantId;
    productDiv.dataset.productName = optionalProduct.name;
    productDiv.innerHTML = `
      <div class="optional-add-ons-card">
        <img src="${optionalProduct.image_url}" alt="${optionalProduct.name}" width="100px" height="100px" loading="lazy" class="optional-addon-image p-image"/>
        <div class="optional-add-ons-info">
          <h2 class="optional-addon-title p-title">${marathi.title}</h2>
          <p class="optional-addon-oneliner liner-text d-none">${marathi.description}</p>
          <div class="optional-addon-price-button-flex">
            <p class="optional-addon-price p-price">
              ${optionalProduct.originalPrice ? `<del>₹${Math.floor(optionalProduct.originalPrice)}</del> ₹${Math.floor(optionalProduct.price)}` : `₹${Math.floor(optionalProduct.price)}`}
            </p>
            <p class="optionalProduct-tag">${optionalProduct.tag}</p>
            <button class="optional-add-btn" data-variant-id="${optionalProduct.variantId}" data-product-name="${optionalProduct.name}" data-product-image="${optionalProduct.image_url}">Add</button>
          </div>
        </div>
      </div>`;
    fragment.appendChild(productDiv);
  });
  productCardContainers.appendChild(fragment);

  document.addEventListener('click', async function (e) {
    const addBtn = e.target.closest('.optional-add-btn');
    if (!addBtn) return;
    const variantId = addBtn.getAttribute('data-variant-id');
    const productName = addBtn.getAttribute('data-product-name');
    const productImage = addBtn.getAttribute('data-product-image');
    fireEvent("addon_add_to_cart_click", state.caseId, variantId, productName);
    addBtn.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/tube-spinner_3.svg?v=1741241123" class="loader-icon" alt="Loading..." style="width: 22px; height: 20px;" />`;
    addBtn.disabled = true;
    addBtn.classList.add('disabled');
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: {} }] })
      });
      updateCartDrawer();
      insertAddOnProductIntoKit(optionalProductBundle, variantId, existingVariantIds);
      updateStrikePriceAfterAddition(response, variantId, 'optional');
      e.target.closest('.optional-add-ons-list').remove();
      addBtn.innerHTML = `Add`;
      addBtn.disabled = false;
      addBtn.classList.remove('disabled');
      if (document.querySelectorAll('.optional-add-ons-list').length === 0) {
        document.querySelector('.optional-add-ons-section').classList.add('d-none');
      }
    } catch (err) { console.error('Error adding to cart:', err); }
  });
}

// ─── INSERT ADD-ON INTO KIT ───────────────────────────────────────────────────

function insertAddOnProductIntoKit(optionalProducts, variantId, existingVariantIds) {
  if (existingVariantIds.has(String(variantId))) return;
  const product = optionalProducts.find(p => p.variantId === variantId);
  if (!product) return;
  const container = document.querySelector('.product-combo-details');
  if (!container) return;

  const insertProductDetails = document.createElement('div');
  insertProductDetails.classList.add('kit-card-container', 'fade-in');
  insertProductDetails.dataset.productId = product.variantId;
  insertProductDetails.dataset.productName = product.name;

  const normalizedProduct = {
    ...product,
    product_id: product.variantId,
    oneLiner: product.one_liner || product.oneliner,
    image_url: { singleImage: product.image_url || product.productImage || product.image },
    price: product.price,
    originalPrice: product.originalPrice
  };

  insertProductDetails.innerHTML = renderProductCard(normalizedProduct, product.one_liner);
  container.appendChild(insertProductDetails);
}

// ─── RESTORE PRODUCT TO OPTIONAL LIST ────────────────────────────────────────

function restoreProductToOptionalList(product, response) {
  const existingVariantIds = new Set(response.product_Ids.map(p => String(p.product_id)));
  const container = document.querySelector('.optional-add-ons-wrapper');
  if (!container || existingVariantIds.has(String(product.variantId))) return;

  const el = document.createElement('div');
  el.classList.add('optional-add-ons-list');
  el.dataset.productId = product.variantId;
  el.innerHTML = `
    <div class="optional-add-ons-card">
      <img src="${product.image_url}" alt="${product.name}" width="100px" height="100px" loading="lazy" class="optional-addon-image p-image"/>
      <div class="optional-add-ons-info">
        <h2 class="optional-addon-title p-title">${product.name}</h2>
        <p class="optional-addon-oneliner liner-text d-none">${product.one_liner}</p>
        <div class="optional-addon-price-button-flex">
          <p class="optional-addon-price p-price">
            ${product.originalPrice ? `<del>₹${Math.floor(product.originalPrice)}</del> ₹${Math.floor(product.price)}` : `₹${Math.floor(product.price)}`}
          </p>
          <p class="optionalProduct-tag">${product.tag}</p>
          <button class="optional-add-btn" data-variant-id="${product.variantId}" data-product-name="${product.name}" data-product-image="${product.image_url}">Add</button>
        </div>
      </div>
    </div>`;
  container.appendChild(el);

  if (document.querySelectorAll('.optional-add-ons-list').length > 0) {
    document.querySelector('.optional-add-ons-section').classList.remove('d-none');
  }
}

// ─── PRICE UPDATE HELPERS ─────────────────────────────────────────────────────

function updateStrikePriceAfterRemoval(response, removedVariantId) {
  const strikeEls = document.querySelectorAll('.strike-cart-total-price');
  const totalEls = document.querySelectorAll('.total-price');
  let currentStrikePrice = parseInt(strikeEls[0]?.textContent.replace(/[^\d]/g, '')) || 0;
  let currentTotalPrice = parseInt(totalEls[0]?.textContent.replace(/[^\d]/g, '')) || 0;

  let removedProduct =
    response.product_Ids.find(p => String(p.product_id) === String(removedVariantId)) ||
    bundleMap?.bundle1?.find(p => String(p.variantId) === String(removedVariantId));
  if (!removedProduct) return;

  let rawStrikePrice = currentStrikePrice - Number(removedProduct.originalPrice || removedProduct.price || 0);
  let rawTotalPrice = currentTotalPrice - Number(removedProduct.price || 0);

  let discountAmount = 0;
  if (window.appliedDiscountMeta && rawTotalPrice >= window.appliedDiscountMeta.minCart) {
    discountAmount = window.appliedDiscountMeta.type === 'percentage'
      ? Math.round((rawTotalPrice * window.appliedDiscountMeta.value) / 100)
      : window.appliedDiscountMeta.value;
  }

  strikeEls.forEach(el => { el.textContent = `₹${Math.round(rawStrikePrice).toLocaleString('en-IN')}`; });
  totalEls.forEach(el => { el.textContent = `₹${Math.round(Math.max(rawTotalPrice - discountAmount, 0)).toLocaleString('en-IN')}`; });
}

function updateStrikePriceAfterAddition(response, variantId, type) {
  const strikeEls = document.querySelectorAll('.strike-cart-total-price');
  const totalEls = document.querySelectorAll('.total-price');
  let currentStrikePrice = parseInt(strikeEls[0]?.textContent.replace(/[^\d]/g, '')) || 0;
  let currentTotalPrice = parseInt(totalEls[0]?.textContent.replace(/[^\d]/g, '')) || 0;

  let addedProduct = type === "kit"
    ? response.product_Ids.find(p => String(p.product_id) === String(variantId))
    : bundleMap?.bundle1?.find(p => String(p.variantId) === String(variantId));
  if (!addedProduct) return;

  let rawStrikePrice = currentStrikePrice + Number(addedProduct.originalPrice || addedProduct.price || 0);
  let rawTotalPrice = currentTotalPrice + Number(addedProduct.price || 0);

  let discountAmount = 0;
  if (window.appliedDiscountMeta && rawTotalPrice >= window.appliedDiscountMeta.minCart) {
    discountAmount = window.appliedDiscountMeta.type === 'percentage'
      ? Math.round((rawTotalPrice * window.appliedDiscountMeta.value) / 100)
      : window.appliedDiscountMeta.value;
  }

  strikeEls.forEach(el => { el.textContent = `₹${Math.round(rawStrikePrice).toLocaleString('en-IN')}`; });
  totalEls.forEach(el => { el.textContent = `₹${Math.round(Math.max(rawTotalPrice - discountAmount, 0)).toLocaleString('en-IN')}`; });
}

// ─── CART HELPERS ─────────────────────────────────────────────────────────────

function removeCartItemByKey(lineItemKey) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: lineItemKey, quantity: 0 })
  })
    .then(res => res.json())
    .then(() => { updateCartDrawer(); })
    .catch(err => console.error('Error removing item:', err));
}

// ─── ANALYTICS ───────────────────────────────────────────────────────────────

function fireEvent(eventName, caseID, productId, productName) {
  fetch("https://public-jgfas325.hav-g.in/eventMoengageWeb", {
    method: "POST",
    headers: { "Content-Type": "application/json", "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90" },
    body: JSON.stringify({
      "eventName": eventName,
      "eventAttributes": { "generalAttributes": { "platform": "web_shopify", "domain": "traya.health", "productId": productId, "productName": productName, "syntheticId": window.location.search.substring(1).split('=')[1] || "default-id" } },
      "caseId": caseID
    })
  });
}

function productFireEvent(eventName, caseID, productName) {
  fetch("https://public-jgfas325.hav-g.in/eventMoengageWeb", {
    method: "POST",
    headers: { "Content-Type": "application/json", "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90" },
    body: JSON.stringify({
      "eventName": eventName,
      "eventAttributes": { "generalAttributes": { "platform": "web_shopify", "domain": "traya.health", "productName": productName, "syntheticId": window.location.search.substring(1).split('=')[1] || "default-id" } },
      "caseId": caseID
    })
  });
}
function fireMiniVideoEvent(eventName, caseID) {
  fetch("https://public-jgfas325.hav-g.in/eventMoengageWeb", {
    method: "POST",
    headers: {"Content-Type": "application/json","Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"},
    body: JSON.stringify({
      "eventName": eventName,
      "eventAttributes": { "generalAttributes": {"platform": "web_shopify","domain": "traya.health","syntheticId": window.location.search.substring(1).split('=')[1] || "default-id"}
      },
      "caseId": caseID
    })
  });
}
function fireExpectationEvent(eventName, caseID, selectedMonth) {
  fetch("https://public-jgfas325.hav-g.in/eventMoengageWeb", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
    },
    body: JSON.stringify({
      "eventName": eventName,
      "eventAttributes": {
        "generalAttributes": {
          "platform": "web_shopify",
          "domain": "traya.health",
          "Number of the month clicked": selectedMonth,
          "syntheticId": window.location.search.substring(1).split('=')[1] || "default-id"
        }
      },
      "caseId": caseID
    })
  });
}
function chatIconClicked(eventName, caseID) {
  fetch("https://public-jgfas325.hav-g.in/eventMoengageWeb", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
    },
    body: JSON.stringify({
      "eventName": eventName,
      "eventAttributes": {
        "generalAttributes": {
          "platform": "web_shopify",
          "domain": "traya.health",
          "syntheticId": window.location.search.substring(1).split('=')[1] || "default-id"
        }
      },
      "caseId": caseID
    })
  });
}
// ─── REMOVED PRODUCT CARD ─────────────────────────────────────────────────────

function renderRemovedProductCard(product) {
  document.querySelector('.removed-products-flex').classList.remove('d-none');
  const container = document.getElementById('removed-products-container');
  const productCard = document.createElement('div');
  productCard.className = 'removed-product';
  const price = product.product_id === "45277154377906"
    ? `₹0`
    : `${product.originalPrice ? `<del>₹${Math.round(product.originalPrice)}</del> ` : ''}₹${Math.round(product.price)}`;
  fireEvent("delete_product", state.caseId, product.product_id, product.name);
  productCard.innerHTML = `
    <div class="removed-products-wrapper">
      <div class="removed-product-image">
        <img src="${product.image_url.singleImage}" width="60" height="60" alt="${product.name}">
      </div>
      <div>
        <div class="removed-products-title">${product.name}</div>
        <div class="removed-products-price">${price}</div>
      </div>
      <button class="add-removed-to-cart-btn" data-variant-id="${product.product_id}">Add to Cart</button>
    </div>`;
  container.appendChild(productCard);
}

// ─── REMOVE POPUP ─────────────────────────────────────────────────────────────
// FIX: use matched?.product (canonical name from popOneLinerData) for the
// Marathi lookup instead of the raw productName from the DOM data-attribute.

function updateRemovePopupContentByProduct(productName, productImage, selectedVariantId) {
  const normalizedName = productName.trim().toLowerCase();
  const matched = popOneLinerData.find(
    item => String(item.productVariantId) === String(selectedVariantId)
  );

  const allowedProductsRaw = [
    "pcos santulan", "pcos", "nourish oil", "Nourish hair oil",
    "thyroid santulan", "Thyro Santulan", "her santulan", "mom santulan",
    "Mom Santulan for Postpartum hair", "iron santulan", "her nourish",
    "hair ras 6", "Hair Ras 06", "hair santulan 1", "hair santulan 2",
    "hair santulan 3", "Hair Santulan 01", "Hair Santulan 02", "Hair Santulan 03",
    "health tatva", "gutt shuddhi", "digest boost",
    "Digest boost for Improved Digestive Ability", "calm ras", "hair ras",
    "nasal ghrit", "consti clear", "Consti Clear for Improved Bowel Movement",
    "scalp oil", "Scalp Oil 100ml with Dandruff Oil Shot",
    "Scalp Oil 100ml with Scalp Health Oil Shot",
    "Scalp Oil 100ml with Calm Oil Shot", "Scalp Oil 100ml with Growth Oil Shot",
  ];
  const allowedProducts = allowedProductsRaw.map(name => name.toLowerCase());
  const showDisclaimer = allowedProducts.some(name => normalizedName.includes(name));

  const disclaimerEl = document.querySelector('.remove-product-desclaimer');
  const disclaimerFlex = document.querySelector('.remove-product-desclaimer-flex');
  if (disclaimerEl && disclaimerFlex) {
    if (showDisclaimer) {
      disclaimerFlex.style.display = "flex";
      disclaimerEl.textContent = normalizedName.includes("hair vitamin for her")
        ? "Itar audhadhan sobhat ghetli jau shaktat."
        : "100% Ayurvedic, itar audhadhan sobhat ghetli jau shaktat.";
    } else {
      disclaimerFlex.style.display = "none";
    }
  }

  const titleElement = document.querySelector('.remove-popup-title');
  const imageElement = document.querySelector('.remove-popup-image');

  // ✅ KEY FIX: use canonical name from popOneLinerData for Marathi lookup
  const canonicalName = matched?.product || productName;
  const marathi = getProductMarathi(canonicalName, matched?.oneliner);

  if (matched) {
    if (titleElement) titleElement.textContent = marathi.description;
    if (imageElement) imageElement.src = productImage || 'fallback.jpg';
  } else {
    if (titleElement) titleElement.textContent = "Are you sure you want to remove this item?";
    if (imageElement && productImage) imageElement.src = productImage;
  }
}

// ─── RESULTS TIMELINE PROGRESS (ARC) ─────────────────────────────────────────
function initResultsTimeline(response) {
  const caseId = state.caseId;
  function getTimelineData(response) {
    const resultsTimeline = {
      nonDandruff: [
        { month: "Month-1", heading: "Skalpche aarogya sudharte",
          subheading: "Tumcha skalp poshit ani santulit ho rahahe, mhanje te solution sathi tayar ahe.",
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_1.webp?v=1769089803",
          milestone: false },
        { month: "Month-2", heading: "Kamzor tutlele kes galltat",
          subheading: "Naveen majboot kes jhade tutlele kes moolapasun bahar dhakelte. Tumhala kahi vadhta kes gallti disu shakate. He prakriyecha bhaag ahe ani fakt 4 haftech chalate.",
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_2.webp?v=1769089793",
          milestone: false },
        { month: "Month-3", heading: "Kes gallti niyantrit yete",
          subheading: "Tumhala kambiing, oiling, shampooing karnyasathi kami kes gallti disu shakate, karan naveen majboot kes moolancha gathitpane bandhale ahe.",
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_3.webp?v=1769089850",
          milestone: true },
        { month: "Month-4", heading: "Naveen kesachi vaadh",
          subheading: "Tumche kes ek niroghi vegane vadhte ani sagle saumya ani smooth wate lagte.",
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Month_4.webp?v=1769089899",
          milestone: false },
        { month: "Month-5", heading: "Jaad ani gulgulit kes, poorn skalp ",
          subheading: "Tumcha skalp poorn wate lagto, karan kes gallti kami ahe ani kes vadhne vegane ho rahahe.",
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_5.webp?v=1769089986",
          milestone: true },
        { month: "Traya for life", heading: "Nirogi kes, Mulapasun majboot",
          subheading: "Tumche kes Traya serum ani tel vaaparun taja theva, jyaane kontinyud results milu shakte.",
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Month_6.webp?v=1769090000",
          milestone: false }
      ],
      dandruff: [
        { month: "Month-1", heading: "Visible dandruff kami hoto.",
          subheading: "Dandruff nighun jato ani tumcha scalp adhik swachha ani kami irritated vatto.",
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_0.webp?v=1770014538",
          milestone: false },
        { month: "Month-2", heading: "Scalp health adhik sudharte",
          subheading: "Tumcha scalp nourish ani balance hotoy, mhanun to treatment sathi tayar hoto.",
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_1.webp?v=1769089803",
          milestone: false },
        { month: "Month-3", heading: "Weak detached kes galtat",
          subheading: "Nave majboot kes june detached kesanna root madhun baher kadhtat. Thoda hairfall vadhlela disu shakto. He process cha bhag ahe ani fakta 4 athavdya sathi aste.",
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_2.webp?v=1769089793",
          milestone: false },
        { month: "Month-4", heading: "Hair fall control madhe yeto",
          subheading: "Combing, oiling, shampoo kartana hairfall kami disel, karan nave majboot kes root la changle attach zalele astat.",
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_3.webp?v=1769089850",
          milestone: true },
        { month: "Month-5", heading: "Hair growth vegane hote",
          subheading: "Tumche kes healthy fatafat vadhatat ani adhik mulayam vattayla lagtat.",
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Month_4.webp?v=1769089899",
          milestone: false },
        { month: "Month-6", heading: "Jaad ani ghandat kesani bharlele scalp",
          subheading: "Hairfall kami hoto ani hair growth vegane hote mhanun scalp adhik kessane bharlela vatto.",
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_5.webp?v=1769089986",
          milestone: true },
        { month: "Traya for life", heading: "Healthy kes – root pasun majboot",
          subheading: "Satat results sathi Traya serum ani oil ne kesanchi kalji ghet raha.",
          image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Month_6.webp?v=1769090000",
          milestone: false }
      ]
    };

    const defaultRC = response?.root_causes?.defaultRootCause || [];
    const primaryRC = response?.root_causes?.primaryRootCause || [];
    const allRootCauses = [...defaultRC, ...primaryRC];

    const hasDandruff = allRootCauses.some(rc =>
      rc?.key?.toLowerCase().includes("dandruff")
    );

    return hasDandruff
      ? resultsTimeline.dandruff
      : resultsTimeline.nonDandruff;
  }

  const monthEl          = document.getElementById("rtpMonth");
  const titleEl          = document.getElementById("rtpTitle");
  const descEl           = document.getElementById("rtpDesc");
  const curveEl          = document.getElementById("rtpCurve");
  const imageBox         = document.querySelector(".rtp-image-placeholder");
  const milestoneTextBox = document.querySelector(".rtp-milestone-achive-text");
  const milestoneNumberEl = document.getElementById("milestoneNumber");

  if (!monthEl || !titleEl || !descEl || !curveEl) return;

  const data = getTimelineData(response);

  // Collect milestone indices for "Milestone #N" labels
  const milestoneIndices = [];
  data.forEach((item, index) => {
    if (item.milestone) milestoneIndices.push(index);
  });

  let autoClickInterval = null;
  let currentIndex      = 0;
  let isAutoClicking    = true;
  let confettiShown     = new Set();
  let confettiTimeout   = null;

  function updateContent(index, isManualClick = false) {
    const item      = data[index];
    const section   = document.querySelector(".results-timeline-progress");
    const rtpContainer = document.querySelector(".rtp-container");

    monthEl.textContent = item.month;
    titleEl.textContent = item.heading;
    descEl.textContent  = item.subheading;

    if (item.image && imageBox) imageBox.src = item.image;

    fireExpectationEvent("expectation_setting_clicked_rp", state.caseId, `month-${index + 1}`);

    document.querySelectorAll(".rtp-node").forEach((el, i) => {
      el.classList.toggle("active", i === index);
    });
    document.querySelectorAll(".rtp-month-text").forEach((el, i) => {
      el.classList.toggle("show", i === index);
    });

    section.classList.remove("is-milestone");

    if (item.milestone && milestoneTextBox) {
      const milestoneNumber = milestoneIndices.indexOf(index) + 1;
      milestoneNumberEl.textContent = `Milestone #${milestoneNumber}`;
      milestoneTextBox.style.display = "flex";
      section.classList.add("is-milestone");

      const shouldShowConfetti = isManualClick || !confettiShown.has(index);
      if (shouldShowConfetti) {
        if (!isManualClick) confettiShown.add(index);
        if (confettiTimeout) clearTimeout(confettiTimeout);

        rtpContainer.style.backgroundImage = 'none';
        void rtpContainer.offsetWidth; // reflow to restart animation

        const confettiUrl = isManualClick
          ? `url(https://cdn.shopify.com/s/files/1/0100/1622/7394/files/https___lottiefiles.com_animations_confetti-on-transparent-background-ajhx1TPBa7.gif?v=1770014641&t=${Date.now()})`
          : 'url(https://cdn.shopify.com/s/files/1/0100/1622/7394/files/https___lottiefiles.com_animations_confetti-on-transparent-background-ajhx1TPBa7.gif?v=1770014641)';

        rtpContainer.style.backgroundImage = confettiUrl;
        confettiTimeout = setTimeout(() => {
          rtpContainer.style.backgroundImage = 'none';
        }, 1200);
      }
    } else {
      if (milestoneTextBox) milestoneTextBox.style.display = "none";
    }

    currentIndex = index;
  }

  function startAutoClick() {
    if (autoClickInterval) clearInterval(autoClickInterval);
    autoClickInterval = setInterval(() => {
      if (!isAutoClicking) { clearInterval(autoClickInterval); return; }
      currentIndex = (currentIndex + 1) % data.length;
      if (currentIndex === 0) confettiShown.clear();
      updateContent(currentIndex);
    }, 3000);
  }

  function stopAutoClick() {
    isAutoClicking = false;
    if (autoClickInterval) { clearInterval(autoClickInterval); autoClickInterval = null; }
  }

  function renderTimeline() {
    curveEl.innerHTML = "";
    data.forEach((item, index) => {
      const nodeContainer = document.createElement("div");
      nodeContainer.style.position = "absolute";
      nodeContainer.style.bottom   = "0";

      const node = document.createElement("div");
      node.className  = "rtp-node";
      node.textContent = index + 1;

      if (item.milestone) {
        const flag = document.createElement("span");
        flag.className = "rtp-flag";
        flag.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/https___lottiefiles.com_animations_flag-animation-Y9v5xnRs1p.gif?v=1770014631" class="rtp-milestone-flag" width="auto" height="auto" alt="Milestone Flag">`;
        node.appendChild(flag);
      }

      const monthText = document.createElement("span");
      monthText.className  = "rtp-month-text";
      monthText.textContent = "MONTH";
      node.appendChild(monthText);

      node.addEventListener("click", () => {
        stopAutoClick();
        updateContent(index, true);
      });

      nodeContainer.appendChild(node);
      curveEl.appendChild(nodeContainer);
    });

    updateContent(0);
  }

  function positionNodesOnArc() {
    const nodes   = document.querySelectorAll(".rtp-node");
    const total   = nodes.length;
    const isMobile = window.innerWidth <= 767;

    if (isMobile) {
      const mobilePositions6 = [
        { left: 9,  bottom: 34 }, { left: 24, bottom: 55 },
        { left: 41, bottom: 67 }, { left: 59, bottom: 67 },
        { left: 76, bottom: 56 }, { left: 91, bottom: 30 }
      ];
      const mobilePositions7 = [
        { left: 7,  bottom: 28 }, { left: 20, bottom: 48 },
        { left: 34, bottom: 60 }, { left: 50, bottom: 66 },
        { left: 66, bottom: 60 }, { left: 80, bottom: 48 },
        { left: 93, bottom: 28 }
      ];
      const positions = total === 7 ? mobilePositions7 : mobilePositions6;
      nodes.forEach((node, i) => {
        if (!positions[i]) return;
        node.parentElement.style.left   = positions[i].left + "%";
        node.parentElement.style.bottom = positions[i].bottom + "px";
      });
      return;
    }

    const startX = 10, endX = 90, minY = 12, maxY = 100;
    nodes.forEach((node, index) => {
      const t = index / (total - 1);
      const x = startX + (endX - startX) * t;
      const y = minY + (4 * maxY * t * (1 - t));
      node.parentElement.style.left   = x + "%";
      node.parentElement.style.bottom = y + "px";
    });

    if (total === 6) {
      nodes[0].parentElement.style.left          = "11%";
      nodes[0].parentElement.style.bottom        = "24px";
      nodes[total - 1].parentElement.style.left  = "89%";
      nodes[total - 1].parentElement.style.bottom = "24px";
    } else if (total === 7) {
      nodes[0].parentElement.style.left          = "10%";
      nodes[0].parentElement.style.bottom        = "20px";
      nodes[total - 1].parentElement.style.left  = "90%";
      nodes[total - 1].parentElement.style.bottom = "20px";
    }
  }

  renderTimeline();
  positionNodesOnArc();
  window.addEventListener("resize", positionNodesOnArc);

  // Intersection Observer — start auto-play only when section enters viewport
  const section = document.querySelector(".results-timeline-progress");
  if (section) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && isAutoClicking) {
          startAutoClick();
        } else if (!entry.isIntersecting && autoClickInterval) {
          clearInterval(autoClickInterval);
          autoClickInterval = null;
        }
      });
    }, { root: null, rootMargin: '0px', threshold: 0.3 });
    observer.observe(section);
  }
}


// ─── RESULTS TIMELINE (CARD / SLICK) ─────────────────────────────────────────
// Used separately if you need the card-based slick slider version.

function renderTimelineCards(timelineData, containerSelector) {
  const container = document.querySelector(containerSelector);
  if (!container) {
    console.warn("Timeline container not found:", containerSelector);
    return;
  }

  container.innerHTML = "";
  let milestoneCounter = 1;

  timelineData.forEach((item, index) => {
    let milestoneHTML = "";
    if (item.milestone) {
      milestoneHTML = `
        <div class="rt-milestone-felxer">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M2.66699 9.1663C2.66699 9.1663 3.33366 8.49963 5.33366 8.49963C7.33366 8.49963 8.66699 9.83297 10.667 9.83297C12.667 9.83297 13.3337 9.1663 13.3337 9.1663V1.99967C13.3337 1.99967 12.667 2.66634 10.667 2.66634C8.66699 2.66634 7.33366 1.33301 5.33366 1.33301C3.33366 1.33301 2.66699 1.99967 2.66699 1.99967V9.1663Z" fill="white" stroke="#F0F0F0" stroke-width="1.2"/>
            <path d="M2.66699 14.6667V9" stroke="#F0F0F0" stroke-width="1.2"/>
          </svg>
          <span class="rt-milestone">Milestone #${milestoneCounter}</span>
        </div>`;
      milestoneCounter++;
    }

    const card = `
      <div class="rt-item">
        <div class="rt-dot-line">
          <span class="rt-dot"></span>
          ${index !== timelineData.length - 1 ? `<span class="rt-line"></span>` : ""}
        </div>
        <div class="rt-content">
          <p class="rt-month">${item.month}</p>
          <h3 class="rt-heading rt-truncate">${item.heading}</h3>
          <p class="rt-subheading rt-truncate">${item.subheading}</p>
          ${milestoneHTML}
        </div>
      </div>`;

    container.insertAdjacentHTML("beforeend", card);
  });

  // Apply Slick only on desktop
  setTimeout(() => {
    if (window.innerWidth > 768) {
      if (!$(container).hasClass("slick-initialized")) {
        $(container).slick({
          slidesToShow: 4, slidesToScroll: 1,
          autoplay: true, autoplaySpeed: 3000,
          arrows: false, dots: false,
          infinite: false, pauseOnHover: false
        }).on("afterChange", function (event, slick, currentSlide) {
          const lastSlide = slick.slideCount - slick.options.slidesToShow;
          if (currentSlide >= lastSlide) {
            setTimeout(() => $(this).slick("slickGoTo", 0), slick.options.autoplaySpeed);
          }
        });
      }
    } else {
      if ($(container).hasClass("slick-initialized")) {
        $(container).slick("unslick");
      }
    }
  }, 50);
}

// experiments here 
function setupHairRoutineBanner(caseId, userStage) {
  const hairRoutineBanner = document.querySelector('.hair-routine-banner');
  if (!hairRoutineBanner) return;
  const normalizedStage = userStage?.toLowerCase().trim();
  const validStage =
    normalizedStage === "hair thinning" ||
    normalizedStage === "side thinning" ||
    normalizedStage === "no widening";
  const validChatCase = caseId && /^[5-9]/.test(caseId);
  if (!validChatCase || validStage) return;
  hairRoutineBanner.classList.remove('d-none');
  hairRoutineBanner.onclick = () => {
    const syntheticId = window.location.search.substring(1).split('=')[1] || "default-id";
    chatIconClicked("web_rp_how_to_use_click", caseId, syntheticId);
    setTimeout(() => {
      const routineUrl = `https://form.traya.health/how-to-use/${caseId}`;
      window.location.href = routineUrl;
    }, 500);
  };
}

// clinical studi page popup 
function initBannerPopup() {
  const validStage =
    state.userHairStage === "hair thinning" ||
    state.userHairStage === "side thinning" ||
    state.userHairStage === "no widening";
  if(!validStage) return;
  const bannerLink = document.querySelector('.traya-banner-link');
  bannerLink.style.display = 'block';
  if (!document.getElementById('bp-popup')) {
    document.body.insertAdjacentHTML('beforeend', `
      <style>
        #bp-overlay { display:none; position:fixed; inset:0; background:rgba(0,0,0,.55); z-index:10000; }
        #bp-popup {
          position: fixed;
          background: #fff;
          z-index: 99999;;
          overflow-y: auto;
          opacity: 0;
          transition: transform 0.35s ease, opacity 0.35s ease;
        }

        /* Desktop — centered modal */
        @media (min-width: 768px) {
          #bp-popup {
            top: 50%; left: 50%;
            width: 812px;
            max-height: 85vh;
            border-radius: 16px;
            transform: translate(-50%, -50%) scale(0.85);
          }
          #bp-popup.bp-open {
            transform: translate(-50%, -50%) scale(1);
            opacity: 1;
          }
        }

        /* Mobile — bottom sheet */
        @media (max-width: 767px) {
          #bp-popup {
            left: 0; right: 0; bottom: 0;
            max-height: 75vh;
            border-radius: 16px 16px 0 0;
            transform: translateY(100%);
          }
          #bp-popup.bp-open {
            transform: translateY(0);
            opacity: 1;
          }
        }
      </style>
      <div id="bp-overlay"></div>
      <div id="bp-popup">
        <div style="position:sticky;top:0;height:0;z-index:3;pointer-events:none;">
          <div style="position:absolute;top:8px;left:0;right:0;display:flex;justify-content:center;"><span style="width:72px;height:4px;flex-shrink:0;border-radius:100px;background:#DEDEDE;"></span></div>
          <button id="bp-close" aria-label="Close" style="position:absolute;top:12px;right:16px;pointer-events:auto;display:flex;width:32px;height:32px;padding:0;justify-content:center;align-items:center;gap:10px;border-radius:999px;opacity:0.8;background:#FFF;border:none;cursor:pointer;flex-shrink:0;">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M12 4L4 12M4 4L12 12" stroke="#262626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
        <div id="bp-content" style="padding:0"></div>
      </div>
    `);
  }

  const overlay = document.getElementById('bp-overlay');
  const popup   = document.getElementById('bp-popup');
  const content = document.getElementById('bp-content');
  let cache        = null;
  let fetchPromise = null;

  function ensureSlickCSS() {
    ['slick.css', 'slick-theme.css'].forEach(function(f) {
      const href = 'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/' + f;
      if (!document.querySelector('link[href="' + href + '"]')) {
        const link = document.createElement('link');
        link.rel  = 'stylesheet';
        link.href = href;
        document.head.appendChild(link);
      }
    });
  }

  function load() {
    if (fetchPromise) return fetchPromise;
    fetchPromise = fetch('/pages/hair-growth-science?pb=0')
      .then(function(r) { return r.text(); })
      .then(function(html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        if (!document.getElementById('bp-styles')) {
          const wrap = document.createElement('div');
          wrap.id = 'bp-styles';
          doc.querySelectorAll('head style').forEach(function(s) {
            const st = document.createElement('style');
            st.textContent = s.textContent;
            wrap.appendChild(st);
          });
          document.head.appendChild(wrap);
        }
        cache = (doc.querySelector('main') || doc.body).innerHTML;
        return cache;
      })
      .catch(function(err) { console.error('BP fetch failed:', err); fetchPromise = null; });
  }

  function render() {
    content.innerHTML = cache;
    content.querySelectorAll('script').forEach(function(old) {
      if (old.textContent.indexOf('cs-slider') > -1) return;
      const s = document.createElement('script');
      if (old.src) { s.src = old.src; s.async = false; }
      else { s.textContent = old.textContent; }
      document.body.appendChild(s);
    });
    ensureSlickCSS();
    waitAndInitCSSlider();
  }

  function waitAndInitCSSlider() {
    if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
      setTimeout(waitAndInitCSSlider, 100);
      return;
    }
    setTimeout(function() {
      const $s = jQuery('#bp-popup .cs-slider');
      if (!$s.length) { console.warn('BP: .cs-slider not found in popup'); return; }
      if ($s.hasClass('slick-initialized')) { $s.slick('unslick'); }
      const $dots  = jQuery('#bp-popup .cs-dots');
      const $label = jQuery('#bp-popup .cs-dot-label');
      $s.slick({
        slidesToShow: 2.2, slidesToScroll: 1, centerMode: false,
        dots: false, arrows: false,
        infinite: false, autoplay: true, autoplaySpeed: 2500, speed: 600,
        responsive: [
          { breakpoint: 1024, settings: { slidesToShow: 2.2, centerMode: false } },
          { breakpoint: 768,  settings: { slidesToShow: 1.2, centerMode: false } }
        ]
      });
      const total = $s.slick('getSlick').slideCount;
      $dots.empty();
      for (var _d = 0; _d < total; _d++) {
        jQuery('<button type="button" class="cs-mdot" aria-label="Go to slide ' + (_d + 1) + '"></button>')
          .toggleClass('is-active', _d === 0)
          .appendTo($dots);
      }
      $dots.on('click', '.cs-mdot', function() { $s.slick('slickGoTo', jQuery(this).index()); });
      if ($label.length) $label.text('1 / ' + total);
      $s.on('afterChange', function(e, slick, i) {
        $dots.find('.cs-mdot').removeClass('is-active').eq(i).addClass('is-active');
        if ($label.length) $label.text((i + 1) + ' / ' + slick.slideCount);
      });
      console.log('BP: CS slider initialised with', total, 'slides');
    }, 200);
  }

  function open() {
    overlay.style.display        = 'block';
    popup.style.display          = 'block';
    document.body.style.overflow = 'hidden';
    popup.scrollTop              = 0;
    requestAnimationFrame(() => popup.classList.add('bp-open'));
    chatIconClicked("hair_science_component_click", caseId);
    load().then(() => render());
  }

  function close() {
    popup.classList.remove('bp-open');
    setTimeout(function() {
      overlay.style.display = 'none';
      popup.style.display   = 'none';
    }, 350);
    document.body.style.overflow = '';
  }

  bannerLink.addEventListener('click', function(e) { e.preventDefault(); open(); });
  document.getElementById('bp-close').addEventListener('click', close);
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') close(); });


  load();
}
